export const yearcnt = [
  {
    "id": "aceprometazine",
    "data": [
      {
        "x": 2004,
        "y": 57
      },
      {
        "x": 2005,
        "y": 110
      },
      {
        "x": 2006,
        "y": 123
      },
      {
        "x": 2007,
        "y": 169
      },
      {
        "x": 2008,
        "y": 188
      },
      {
        "x": 2009,
        "y": 200
      },
      {
        "x": 2010,
        "y": 270
      },
      {
        "x": 2011,
        "y": 396
      },
      {
        "x": 2012,
        "y": 397
      },
      {
        "x": 2013,
        "y": 400
      },
      {
        "x": 2014,
        "y": 440
      }
    ]
  },
  {
    "id": "alcuronium",
    "data": [
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 56
      },
      {
        "x": 2007,
        "y": 56
      },
      {
        "x": 2008,
        "y": 56
      },
      {
        "x": 2009,
        "y": 56
      },
      {
        "x": 2010,
        "y": 56
      },
      {
        "x": 2011,
        "y": 56
      },
      {
        "x": 2012,
        "y": 56
      },
      {
        "x": 2013,
        "y": 56
      },
      {
        "x": 2014,
        "y": 68
      }
    ]
  },
  {
    "id": "allobarbital",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 31
      },
      {
        "x": 2007,
        "y": 40
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 40
      },
      {
        "x": 2011,
        "y": 40
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 54
      },
      {
        "x": 2014,
        "y": 68
      }
    ]
  },
  {
    "id": "allylestrenol",
    "data": [
      {
        "x": 2004,
        "y": 11
      },
      {
        "x": 2005,
        "y": 43
      },
      {
        "x": 2006,
        "y": 76
      },
      {
        "x": 2007,
        "y": 189
      },
      {
        "x": 2008,
        "y": 242
      },
      {
        "x": 2009,
        "y": 248
      },
      {
        "x": 2010,
        "y": 248
      },
      {
        "x": 2011,
        "y": 259
      },
      {
        "x": 2012,
        "y": 285
      },
      {
        "x": 2013,
        "y": 296
      },
      {
        "x": 2014,
        "y": 329
      }
    ]
  },
  {
    "id": "aloxiprin",
    "data": [
      {
        "x": 2004,
        "y": 68
      },
      {
        "x": 2005,
        "y": 125
      },
      {
        "x": 2006,
        "y": 213
      },
      {
        "x": 2007,
        "y": 370
      },
      {
        "x": 2008,
        "y": 464
      },
      {
        "x": 2009,
        "y": 464
      },
      {
        "x": 2010,
        "y": 464
      },
      {
        "x": 2011,
        "y": 464
      },
      {
        "x": 2012,
        "y": 464
      },
      {
        "x": 2013,
        "y": 467
      },
      {
        "x": 2014,
        "y": 468
      }
    ]
  },
  {
    "id": "altretamine",
    "data": [
      {
        "x": 2004,
        "y": 51
      },
      {
        "x": 2005,
        "y": 64
      },
      {
        "x": 2006,
        "y": 88
      },
      {
        "x": 2007,
        "y": 127
      },
      {
        "x": 2008,
        "y": 140
      },
      {
        "x": 2009,
        "y": 152
      },
      {
        "x": 2010,
        "y": 156
      },
      {
        "x": 2011,
        "y": 184
      },
      {
        "x": 2012,
        "y": 217
      },
      {
        "x": 2013,
        "y": 310
      },
      {
        "x": 2014,
        "y": 541
      }
    ]
  },
  {
    "id": "aluminum",
    "data": [
      {
        "x": 2004,
        "y": 1
      },
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 81
      },
      {
        "x": 2007,
        "y": 144
      },
      {
        "x": 2008,
        "y": 188
      },
      {
        "x": 2009,
        "y": 355
      },
      {
        "x": 2010,
        "y": 372
      },
      {
        "x": 2011,
        "y": 410
      },
      {
        "x": 2012,
        "y": 1000
      },
      {
        "x": 2013,
        "y": 1020
      },
      {
        "x": 2014,
        "y": 1073
      }
    ]
  },
  {
    "id": "aluminum oxide",
    "data": [
      {
        "x": 2004,
        "y": 32
      },
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 32
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 32
      }
    ]
  },
  {
    "id": "amdinocillin pivoxil",
    "data": [
      {
        "x": 2004,
        "y": 21
      },
      {
        "x": 2005,
        "y": 48
      },
      {
        "x": 2006,
        "y": 137
      },
      {
        "x": 2007,
        "y": 168
      },
      {
        "x": 2008,
        "y": 210
      },
      {
        "x": 2009,
        "y": 240
      },
      {
        "x": 2010,
        "y": 284
      },
      {
        "x": 2011,
        "y": 294
      },
      {
        "x": 2012,
        "y": 351
      },
      {
        "x": 2013,
        "y": 562
      },
      {
        "x": 2014,
        "y": 580
      }
    ]
  },
  {
    "id": "aminoglutethimide",
    "data": [
      {
        "x": 2004,
        "y": 97
      },
      {
        "x": 2005,
        "y": 271
      },
      {
        "x": 2006,
        "y": 374
      },
      {
        "x": 2007,
        "y": 476
      },
      {
        "x": 2008,
        "y": 491
      },
      {
        "x": 2009,
        "y": 492
      },
      {
        "x": 2010,
        "y": 495
      },
      {
        "x": 2011,
        "y": 662
      },
      {
        "x": 2012,
        "y": 736
      },
      {
        "x": 2013,
        "y": 748
      },
      {
        "x": 2014,
        "y": 760
      }
    ]
  },
  {
    "id": "ammonium chloride",
    "data": [
      {
        "x": 2004,
        "y": 36
      },
      {
        "x": 2005,
        "y": 42
      },
      {
        "x": 2006,
        "y": 74
      },
      {
        "x": 2007,
        "y": 88
      },
      {
        "x": 2008,
        "y": 106
      },
      {
        "x": 2009,
        "y": 205
      },
      {
        "x": 2010,
        "y": 329
      },
      {
        "x": 2011,
        "y": 387
      },
      {
        "x": 2012,
        "y": 446
      },
      {
        "x": 2013,
        "y": 554
      },
      {
        "x": 2014,
        "y": 576
      }
    ]
  },
  {
    "id": "aniracetam",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 40
      },
      {
        "x": 2011,
        "y": 40
      },
      {
        "x": 2012,
        "y": 84
      },
      {
        "x": 2013,
        "y": 172
      },
      {
        "x": 2014,
        "y": 188
      }
    ]
  },
  {
    "id": "artemether",
    "data": [
      {
        "x": 2004,
        "y": 20
      },
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 36
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 76
      },
      {
        "x": 2011,
        "y": 246
      },
      {
        "x": 2012,
        "y": 399
      },
      {
        "x": 2013,
        "y": 456
      },
      {
        "x": 2014,
        "y": 485
      }
    ]
  },
  {
    "id": "astemizole",
    "data": [
      {
        "x": 2004,
        "y": 52
      },
      {
        "x": 2005,
        "y": 98
      },
      {
        "x": 2006,
        "y": 120
      },
      {
        "x": 2007,
        "y": 170
      },
      {
        "x": 2008,
        "y": 288
      },
      {
        "x": 2009,
        "y": 394
      },
      {
        "x": 2010,
        "y": 568
      },
      {
        "x": 2011,
        "y": 906
      },
      {
        "x": 2012,
        "y": 942
      },
      {
        "x": 2013,
        "y": 946
      },
      {
        "x": 2014,
        "y": 961
      }
    ]
  },
  {
    "id": "aurothioglucose",
    "data": [
      {
        "x": 2004,
        "y": 54
      },
      {
        "x": 2005,
        "y": 163
      },
      {
        "x": 2006,
        "y": 236
      },
      {
        "x": 2007,
        "y": 241
      },
      {
        "x": 2008,
        "y": 261
      },
      {
        "x": 2009,
        "y": 292
      },
      {
        "x": 2010,
        "y": 298
      },
      {
        "x": 2011,
        "y": 378
      },
      {
        "x": 2012,
        "y": 404
      },
      {
        "x": 2013,
        "y": 424
      },
      {
        "x": 2014,
        "y": 428
      }
    ]
  },
  {
    "id": "azatadine",
    "data": [
      {
        "x": 2004,
        "y": 122
      },
      {
        "x": 2005,
        "y": 128
      },
      {
        "x": 2006,
        "y": 130
      },
      {
        "x": 2007,
        "y": 132
      },
      {
        "x": 2008,
        "y": 132
      },
      {
        "x": 2009,
        "y": 132
      },
      {
        "x": 2010,
        "y": 154
      },
      {
        "x": 2011,
        "y": 168
      },
      {
        "x": 2012,
        "y": 180
      },
      {
        "x": 2013,
        "y": 184
      },
      {
        "x": 2014,
        "y": 202
      }
    ]
  },
  {
    "id": "bamethan",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "bencyclane",
    "data": [
      {
        "x": 2004,
        "y": 32
      },
      {
        "x": 2005,
        "y": 84
      },
      {
        "x": 2006,
        "y": 90
      },
      {
        "x": 2007,
        "y": 96
      },
      {
        "x": 2008,
        "y": 141
      },
      {
        "x": 2009,
        "y": 156
      },
      {
        "x": 2010,
        "y": 156
      },
      {
        "x": 2011,
        "y": 156
      },
      {
        "x": 2012,
        "y": 156
      },
      {
        "x": 2013,
        "y": 197
      },
      {
        "x": 2014,
        "y": 244
      }
    ]
  },
  {
    "id": "benorilate",
    "data": [
      {
        "x": 2004,
        "y": 56
      },
      {
        "x": 2005,
        "y": 72
      },
      {
        "x": 2006,
        "y": 72
      },
      {
        "x": 2007,
        "y": 114
      },
      {
        "x": 2008,
        "y": 131
      },
      {
        "x": 2009,
        "y": 132
      },
      {
        "x": 2010,
        "y": 132
      },
      {
        "x": 2011,
        "y": 132
      },
      {
        "x": 2012,
        "y": 132
      },
      {
        "x": 2013,
        "y": 141
      },
      {
        "x": 2014,
        "y": 144
      }
    ]
  },
  {
    "id": "benzthiazide",
    "data": [
      {
        "x": 2004,
        "y": 13
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 28
      },
      {
        "x": 2013,
        "y": 72
      },
      {
        "x": 2014,
        "y": 95
      }
    ]
  },
  {
    "id": "beta-alanine",
    "data": [
      {
        "x": 2004,
        "y": 27
      },
      {
        "x": 2005,
        "y": 84
      },
      {
        "x": 2006,
        "y": 100
      },
      {
        "x": 2007,
        "y": 127
      },
      {
        "x": 2008,
        "y": 160
      },
      {
        "x": 2009,
        "y": 172
      },
      {
        "x": 2010,
        "y": 176
      },
      {
        "x": 2011,
        "y": 190
      },
      {
        "x": 2012,
        "y": 196
      },
      {
        "x": 2013,
        "y": 196
      },
      {
        "x": 2014,
        "y": 199
      }
    ]
  },
  {
    "id": "bismuth subcarbonate",
    "data": [
      {
        "x": 2004,
        "y": 59
      },
      {
        "x": 2005,
        "y": 76
      },
      {
        "x": 2006,
        "y": 76
      },
      {
        "x": 2007,
        "y": 76
      },
      {
        "x": 2008,
        "y": 76
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 76
      },
      {
        "x": 2011,
        "y": 76
      },
      {
        "x": 2012,
        "y": 88
      },
      {
        "x": 2013,
        "y": 92
      },
      {
        "x": 2014,
        "y": 92
      }
    ]
  },
  {
    "id": "bismuth subgallate",
    "data": [
      {
        "x": 2004,
        "y": 33
      },
      {
        "x": 2005,
        "y": 44
      },
      {
        "x": 2006,
        "y": 44
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 140
      },
      {
        "x": 2009,
        "y": 240
      },
      {
        "x": 2010,
        "y": 240
      },
      {
        "x": 2011,
        "y": 240
      },
      {
        "x": 2012,
        "y": 242
      },
      {
        "x": 2013,
        "y": 288
      },
      {
        "x": 2014,
        "y": 304
      }
    ]
  },
  {
    "id": "bitolterol",
    "data": [
      {
        "x": 2004,
        "y": 1
      },
      {
        "x": 2005,
        "y": 51
      },
      {
        "x": 2006,
        "y": 80
      },
      {
        "x": 2007,
        "y": 106
      },
      {
        "x": 2008,
        "y": 148
      },
      {
        "x": 2009,
        "y": 162
      },
      {
        "x": 2010,
        "y": 216
      },
      {
        "x": 2011,
        "y": 272
      },
      {
        "x": 2012,
        "y": 288
      },
      {
        "x": 2013,
        "y": 288
      },
      {
        "x": 2014,
        "y": 302
      }
    ]
  },
  {
    "id": "bopindolol",
    "data": [
      {
        "x": 2004,
        "y": 36
      },
      {
        "x": 2005,
        "y": 99
      },
      {
        "x": 2006,
        "y": 145
      },
      {
        "x": 2007,
        "y": 202
      },
      {
        "x": 2008,
        "y": 208
      },
      {
        "x": 2009,
        "y": 208
      },
      {
        "x": 2010,
        "y": 208
      },
      {
        "x": 2011,
        "y": 208
      },
      {
        "x": 2012,
        "y": 216
      },
      {
        "x": 2013,
        "y": 216
      },
      {
        "x": 2014,
        "y": 216
      }
    ]
  },
  {
    "id": "budipine",
    "data": [
      {
        "x": 2004,
        "y": 12
      },
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "bufexamac",
    "data": [
      {
        "x": 2004,
        "y": 70
      },
      {
        "x": 2005,
        "y": 89
      },
      {
        "x": 2006,
        "y": 195
      },
      {
        "x": 2007,
        "y": 248
      },
      {
        "x": 2008,
        "y": 279
      },
      {
        "x": 2009,
        "y": 350
      },
      {
        "x": 2010,
        "y": 486
      },
      {
        "x": 2011,
        "y": 514
      },
      {
        "x": 2012,
        "y": 535
      },
      {
        "x": 2013,
        "y": 556
      },
      {
        "x": 2014,
        "y": 556
      }
    ]
  },
  {
    "id": "butabarbital",
    "data": [
      {
        "x": 2004,
        "y": 73
      },
      {
        "x": 2005,
        "y": 137
      },
      {
        "x": 2006,
        "y": 237
      },
      {
        "x": 2007,
        "y": 328
      },
      {
        "x": 2008,
        "y": 458
      },
      {
        "x": 2009,
        "y": 496
      },
      {
        "x": 2010,
        "y": 552
      },
      {
        "x": 2011,
        "y": 623
      },
      {
        "x": 2012,
        "y": 1340
      },
      {
        "x": 2013,
        "y": 1496
      },
      {
        "x": 2014,
        "y": 1536
      }
    ]
  },
  {
    "id": "buthiazide",
    "data": [
      {
        "x": 2004,
        "y": 3
      },
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "calcium gluceptate",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 15
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 19
      }
    ]
  },
  {
    "id": "carbetapentane",
    "data": [
      {
        "x": 2004,
        "y": 20
      },
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 77
      },
      {
        "x": 2010,
        "y": 458
      },
      {
        "x": 2011,
        "y": 593
      },
      {
        "x": 2012,
        "y": 655
      },
      {
        "x": 2013,
        "y": 760
      },
      {
        "x": 2014,
        "y": 765
      }
    ]
  },
  {
    "id": "carbromal",
    "data": [
      {
        "x": 2004,
        "y": 3
      },
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 15
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 19
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "carprofen",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 19
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 37
      },
      {
        "x": 2012,
        "y": 332
      },
      {
        "x": 2013,
        "y": 346
      },
      {
        "x": 2014,
        "y": 400
      }
    ]
  },
  {
    "id": "cetiedil",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "chloroxine",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 80
      },
      {
        "x": 2006,
        "y": 202
      },
      {
        "x": 2007,
        "y": 260
      },
      {
        "x": 2008,
        "y": 396
      },
      {
        "x": 2009,
        "y": 397
      },
      {
        "x": 2010,
        "y": 461
      },
      {
        "x": 2011,
        "y": 556
      },
      {
        "x": 2012,
        "y": 568
      },
      {
        "x": 2013,
        "y": 574
      },
      {
        "x": 2014,
        "y": 576
      }
    ]
  },
  {
    "id": "chlortetracycline",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 17
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 74
      },
      {
        "x": 2011,
        "y": 94
      },
      {
        "x": 2012,
        "y": 130
      },
      {
        "x": 2013,
        "y": 164
      },
      {
        "x": 2014,
        "y": 194
      }
    ]
  },
  {
    "id": "clofoctol",
    "data": [
      {
        "x": 2004,
        "y": 32
      },
      {
        "x": 2005,
        "y": 60
      },
      {
        "x": 2006,
        "y": 60
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 60
      },
      {
        "x": 2009,
        "y": 60
      },
      {
        "x": 2010,
        "y": 60
      },
      {
        "x": 2011,
        "y": 111
      },
      {
        "x": 2012,
        "y": 128
      },
      {
        "x": 2013,
        "y": 128
      },
      {
        "x": 2014,
        "y": 128
      }
    ]
  },
  {
    "id": "cyclopenthiazide",
    "data": [
      {
        "x": 2004,
        "y": 15
      },
      {
        "x": 2005,
        "y": 24
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 27
      },
      {
        "x": 2008,
        "y": 36
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 87
      },
      {
        "x": 2011,
        "y": 107
      },
      {
        "x": 2012,
        "y": 110
      },
      {
        "x": 2013,
        "y": 118
      },
      {
        "x": 2014,
        "y": 126
      }
    ]
  },
  {
    "id": "dalfopristin",
    "data": [
      {
        "x": 2004,
        "y": 90
      },
      {
        "x": 2005,
        "y": 364
      },
      {
        "x": 2006,
        "y": 588
      },
      {
        "x": 2007,
        "y": 665
      },
      {
        "x": 2008,
        "y": 705
      },
      {
        "x": 2009,
        "y": 818
      },
      {
        "x": 2010,
        "y": 910
      },
      {
        "x": 2011,
        "y": 1056
      },
      {
        "x": 2012,
        "y": 1235
      },
      {
        "x": 2013,
        "y": 1378
      },
      {
        "x": 2014,
        "y": 1560
      }
    ]
  },
  {
    "id": "dapiprazole",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 14
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 506
      },
      {
        "x": 2013,
        "y": 512
      },
      {
        "x": 2014,
        "y": 527
      }
    ]
  },
  {
    "id": "deanol",
    "data": [
      {
        "x": 2004,
        "y": 40
      },
      {
        "x": 2005,
        "y": 48
      },
      {
        "x": 2006,
        "y": 50
      },
      {
        "x": 2007,
        "y": 52
      },
      {
        "x": 2008,
        "y": 75
      },
      {
        "x": 2009,
        "y": 88
      },
      {
        "x": 2010,
        "y": 104
      },
      {
        "x": 2011,
        "y": 110
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 144
      },
      {
        "x": 2014,
        "y": 152
      }
    ]
  },
  {
    "id": "demecarium",
    "data": [
      {
        "x": 2004,
        "y": 9
      },
      {
        "x": 2005,
        "y": 13
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 55
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 74
      },
      {
        "x": 2010,
        "y": 94
      },
      {
        "x": 2011,
        "y": 122
      },
      {
        "x": 2012,
        "y": 129
      },
      {
        "x": 2013,
        "y": 161
      },
      {
        "x": 2014,
        "y": 164
      }
    ]
  },
  {
    "id": "deserpidine",
    "data": [
      {
        "x": 2004,
        "y": 5
      },
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 66
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 246
      },
      {
        "x": 2013,
        "y": 304
      },
      {
        "x": 2014,
        "y": 304
      }
    ]
  },
  {
    "id": "dexbrompheniramine",
    "data": [
      {
        "x": 2004,
        "y": 391
      },
      {
        "x": 2005,
        "y": 1011
      },
      {
        "x": 2006,
        "y": 2081
      },
      {
        "x": 2007,
        "y": 2594
      },
      {
        "x": 2008,
        "y": 3222
      },
      {
        "x": 2009,
        "y": 4232
      },
      {
        "x": 2010,
        "y": 5220
      },
      {
        "x": 2011,
        "y": 6167
      },
      {
        "x": 2012,
        "y": 7987
      },
      {
        "x": 2013,
        "y": 8863
      },
      {
        "x": 2014,
        "y": 9718
      }
    ]
  },
  {
    "id": "dichloralphenazone",
    "data": [
      {
        "x": 2004,
        "y": 909
      },
      {
        "x": 2005,
        "y": 3158
      },
      {
        "x": 2006,
        "y": 6085
      },
      {
        "x": 2007,
        "y": 7552
      },
      {
        "x": 2008,
        "y": 8826
      },
      {
        "x": 2009,
        "y": 10745
      },
      {
        "x": 2010,
        "y": 12522
      },
      {
        "x": 2011,
        "y": 15911
      },
      {
        "x": 2012,
        "y": 20904
      },
      {
        "x": 2013,
        "y": 24134
      },
      {
        "x": 2014,
        "y": 27345
      }
    ]
  },
  {
    "id": "dicumarol",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 10
      },
      {
        "x": 2006,
        "y": 128
      },
      {
        "x": 2007,
        "y": 193
      },
      {
        "x": 2008,
        "y": 224
      },
      {
        "x": 2009,
        "y": 233
      },
      {
        "x": 2010,
        "y": 252
      },
      {
        "x": 2011,
        "y": 270
      },
      {
        "x": 2012,
        "y": 345
      },
      {
        "x": 2013,
        "y": 383
      },
      {
        "x": 2014,
        "y": 396
      }
    ]
  },
  {
    "id": "dienestrol",
    "data": [
      {
        "x": 2004,
        "y": 20
      },
      {
        "x": 2005,
        "y": 25
      },
      {
        "x": 2006,
        "y": 30
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 38
      },
      {
        "x": 2011,
        "y": 40
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "diethyltoluamide",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "difenoxin",
    "data": [
      {
        "x": 2004,
        "y": 56
      },
      {
        "x": 2005,
        "y": 103
      },
      {
        "x": 2006,
        "y": 135
      },
      {
        "x": 2007,
        "y": 186
      },
      {
        "x": 2008,
        "y": 192
      },
      {
        "x": 2009,
        "y": 192
      },
      {
        "x": 2010,
        "y": 192
      },
      {
        "x": 2011,
        "y": 198
      },
      {
        "x": 2012,
        "y": 216
      },
      {
        "x": 2013,
        "y": 219
      },
      {
        "x": 2014,
        "y": 220
      }
    ]
  },
  {
    "id": "dipipanone",
    "data": [
      {
        "x": 2004,
        "y": 1
      },
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "dirithromycin",
    "data": [
      {
        "x": 2004,
        "y": 82
      },
      {
        "x": 2005,
        "y": 244
      },
      {
        "x": 2006,
        "y": 429
      },
      {
        "x": 2007,
        "y": 488
      },
      {
        "x": 2008,
        "y": 488
      },
      {
        "x": 2009,
        "y": 564
      },
      {
        "x": 2010,
        "y": 664
      },
      {
        "x": 2011,
        "y": 738
      },
      {
        "x": 2012,
        "y": 1116
      },
      {
        "x": 2013,
        "y": 1134
      },
      {
        "x": 2014,
        "y": 1156
      }
    ]
  },
  {
    "id": "dopexamine",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 100
      },
      {
        "x": 2006,
        "y": 160
      },
      {
        "x": 2007,
        "y": 172
      },
      {
        "x": 2008,
        "y": 172
      },
      {
        "x": 2009,
        "y": 172
      },
      {
        "x": 2010,
        "y": 172
      },
      {
        "x": 2011,
        "y": 172
      },
      {
        "x": 2012,
        "y": 172
      },
      {
        "x": 2013,
        "y": 172
      },
      {
        "x": 2014,
        "y": 172
      }
    ]
  },
  {
    "id": "edrophonium",
    "data": [
      {
        "x": 2004,
        "y": 44
      },
      {
        "x": 2005,
        "y": 76
      },
      {
        "x": 2006,
        "y": 100
      },
      {
        "x": 2007,
        "y": 100
      },
      {
        "x": 2008,
        "y": 104
      },
      {
        "x": 2009,
        "y": 112
      },
      {
        "x": 2010,
        "y": 124
      },
      {
        "x": 2011,
        "y": 136
      },
      {
        "x": 2012,
        "y": 148
      },
      {
        "x": 2013,
        "y": 148
      },
      {
        "x": 2014,
        "y": 169
      }
    ]
  },
  {
    "id": "encainide",
    "data": [
      {
        "x": 2004,
        "y": 44
      },
      {
        "x": 2005,
        "y": 107
      },
      {
        "x": 2006,
        "y": 146
      },
      {
        "x": 2007,
        "y": 180
      },
      {
        "x": 2008,
        "y": 180
      },
      {
        "x": 2009,
        "y": 180
      },
      {
        "x": 2010,
        "y": 180
      },
      {
        "x": 2011,
        "y": 180
      },
      {
        "x": 2012,
        "y": 192
      },
      {
        "x": 2013,
        "y": 192
      },
      {
        "x": 2014,
        "y": 192
      }
    ]
  },
  {
    "id": "enoximone",
    "data": [
      {
        "x": 2004,
        "y": 118
      },
      {
        "x": 2005,
        "y": 148
      },
      {
        "x": 2006,
        "y": 166
      },
      {
        "x": 2007,
        "y": 184
      },
      {
        "x": 2008,
        "y": 184
      },
      {
        "x": 2009,
        "y": 205
      },
      {
        "x": 2010,
        "y": 220
      },
      {
        "x": 2011,
        "y": 220
      },
      {
        "x": 2012,
        "y": 228
      },
      {
        "x": 2013,
        "y": 228
      },
      {
        "x": 2014,
        "y": 228
      }
    ]
  },
  {
    "id": "ergonovine",
    "data": [
      {
        "x": 2004,
        "y": 96
      },
      {
        "x": 2005,
        "y": 196
      },
      {
        "x": 2006,
        "y": 196
      },
      {
        "x": 2007,
        "y": 207
      },
      {
        "x": 2008,
        "y": 280
      },
      {
        "x": 2009,
        "y": 508
      },
      {
        "x": 2010,
        "y": 572
      },
      {
        "x": 2011,
        "y": 578
      },
      {
        "x": 2012,
        "y": 611
      },
      {
        "x": 2013,
        "y": 652
      },
      {
        "x": 2014,
        "y": 749
      }
    ]
  },
  {
    "id": "ethacridine",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 18
      }
    ]
  },
  {
    "id": "ethanolamine",
    "data": [
      {
        "x": 2004,
        "y": 189
      },
      {
        "x": 2005,
        "y": 299
      },
      {
        "x": 2006,
        "y": 380
      },
      {
        "x": 2007,
        "y": 470
      },
      {
        "x": 2008,
        "y": 509
      },
      {
        "x": 2009,
        "y": 536
      },
      {
        "x": 2010,
        "y": 536
      },
      {
        "x": 2011,
        "y": 569
      },
      {
        "x": 2012,
        "y": 580
      },
      {
        "x": 2013,
        "y": 580
      },
      {
        "x": 2014,
        "y": 604
      }
    ]
  },
  {
    "id": "ethchlorvynol",
    "data": [
      {
        "x": 2004,
        "y": 27
      },
      {
        "x": 2005,
        "y": 45
      },
      {
        "x": 2006,
        "y": 108
      },
      {
        "x": 2007,
        "y": 252
      },
      {
        "x": 2008,
        "y": 284
      },
      {
        "x": 2009,
        "y": 294
      },
      {
        "x": 2010,
        "y": 307
      },
      {
        "x": 2011,
        "y": 308
      },
      {
        "x": 2012,
        "y": 308
      },
      {
        "x": 2013,
        "y": 311
      },
      {
        "x": 2014,
        "y": 335
      }
    ]
  },
  {
    "id": "ethyl salicylate",
    "data": [
      {
        "x": 2004,
        "y": 8
      },
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 32
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 32
      }
    ]
  },
  {
    "id": "ethylmorphine",
    "data": [
      {
        "x": 2004,
        "y": 1
      },
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 64
      },
      {
        "x": 2008,
        "y": 71
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 86
      },
      {
        "x": 2011,
        "y": 120
      },
      {
        "x": 2012,
        "y": 140
      },
      {
        "x": 2013,
        "y": 196
      },
      {
        "x": 2014,
        "y": 256
      }
    ]
  },
  {
    "id": "ethynodiol",
    "data": [
      {
        "x": 2004,
        "y": 12
      },
      {
        "x": 2005,
        "y": 31
      },
      {
        "x": 2006,
        "y": 102
      },
      {
        "x": 2007,
        "y": 128
      },
      {
        "x": 2008,
        "y": 132
      },
      {
        "x": 2009,
        "y": 132
      },
      {
        "x": 2010,
        "y": 132
      },
      {
        "x": 2011,
        "y": 132
      },
      {
        "x": 2012,
        "y": 132
      },
      {
        "x": 2013,
        "y": 132
      },
      {
        "x": 2014,
        "y": 134
      }
    ]
  },
  {
    "id": "etofenamate",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 11
      },
      {
        "x": 2006,
        "y": 23
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 55
      },
      {
        "x": 2010,
        "y": 93
      },
      {
        "x": 2011,
        "y": 127
      },
      {
        "x": 2012,
        "y": 185
      },
      {
        "x": 2013,
        "y": 295
      },
      {
        "x": 2014,
        "y": 323
      }
    ]
  },
  {
    "id": "eucalyptol",
    "data": [
      {
        "x": 2004,
        "y": 24
      },
      {
        "x": 2005,
        "y": 64
      },
      {
        "x": 2006,
        "y": 150
      },
      {
        "x": 2007,
        "y": 169
      },
      {
        "x": 2008,
        "y": 210
      },
      {
        "x": 2009,
        "y": 376
      },
      {
        "x": 2010,
        "y": 655
      },
      {
        "x": 2011,
        "y": 808
      },
      {
        "x": 2012,
        "y": 838
      },
      {
        "x": 2013,
        "y": 950
      },
      {
        "x": 2014,
        "y": 1014
      }
    ]
  },
  {
    "id": "fenoxazoline",
    "data": [
      {
        "x": 2004,
        "y": 11
      },
      {
        "x": 2005,
        "y": 27
      },
      {
        "x": 2006,
        "y": 28
      },
      {
        "x": 2007,
        "y": 28
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 96
      },
      {
        "x": 2011,
        "y": 96
      },
      {
        "x": 2012,
        "y": 96
      },
      {
        "x": 2013,
        "y": 183
      },
      {
        "x": 2014,
        "y": 305
      }
    ]
  },
  {
    "id": "fenproporex",
    "data": [
      {
        "x": 2004,
        "y": 12
      },
      {
        "x": 2005,
        "y": 19
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 23
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 34
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 70
      },
      {
        "x": 2013,
        "y": 89
      },
      {
        "x": 2014,
        "y": 101
      }
    ]
  },
  {
    "id": "fenticonazole",
    "data": [
      {
        "x": 2004,
        "y": 143
      },
      {
        "x": 2005,
        "y": 173
      },
      {
        "x": 2006,
        "y": 176
      },
      {
        "x": 2007,
        "y": 176
      },
      {
        "x": 2008,
        "y": 176
      },
      {
        "x": 2009,
        "y": 208
      },
      {
        "x": 2010,
        "y": 208
      },
      {
        "x": 2011,
        "y": 208
      },
      {
        "x": 2012,
        "y": 224
      },
      {
        "x": 2013,
        "y": 289
      },
      {
        "x": 2014,
        "y": 340
      }
    ]
  },
  {
    "id": "feprazone",
    "data": [
      {
        "x": 2004,
        "y": 17
      },
      {
        "x": 2005,
        "y": 28
      },
      {
        "x": 2006,
        "y": 60
      },
      {
        "x": 2007,
        "y": 92
      },
      {
        "x": 2008,
        "y": 92
      },
      {
        "x": 2009,
        "y": 92
      },
      {
        "x": 2010,
        "y": 92
      },
      {
        "x": 2011,
        "y": 92
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 92
      },
      {
        "x": 2014,
        "y": 92
      }
    ]
  },
  {
    "id": "ferric chloride",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 11
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 18
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "ferrous aspartate",
    "data": [
      {
        "x": 2004,
        "y": 13
      },
      {
        "x": 2005,
        "y": 52
      },
      {
        "x": 2006,
        "y": 60
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 60
      },
      {
        "x": 2009,
        "y": 60
      },
      {
        "x": 2010,
        "y": 60
      },
      {
        "x": 2011,
        "y": 60
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "fleroxacin",
    "data": [
      {
        "x": 2004,
        "y": 46
      },
      {
        "x": 2005,
        "y": 205
      },
      {
        "x": 2006,
        "y": 213
      },
      {
        "x": 2007,
        "y": 224
      },
      {
        "x": 2008,
        "y": 242
      },
      {
        "x": 2009,
        "y": 252
      },
      {
        "x": 2010,
        "y": 284
      },
      {
        "x": 2011,
        "y": 332
      },
      {
        "x": 2012,
        "y": 332
      },
      {
        "x": 2013,
        "y": 332
      },
      {
        "x": 2014,
        "y": 332
      }
    ]
  },
  {
    "id": "fluocortolone",
    "data": [
      {
        "x": 2004,
        "y": 36
      },
      {
        "x": 2005,
        "y": 78
      },
      {
        "x": 2006,
        "y": 91
      },
      {
        "x": 2007,
        "y": 100
      },
      {
        "x": 2008,
        "y": 175
      },
      {
        "x": 2009,
        "y": 211
      },
      {
        "x": 2010,
        "y": 220
      },
      {
        "x": 2011,
        "y": 304
      },
      {
        "x": 2012,
        "y": 304
      },
      {
        "x": 2013,
        "y": 344
      },
      {
        "x": 2014,
        "y": 350
      }
    ]
  },
  {
    "id": "fomepizole",
    "data": [
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 21
      },
      {
        "x": 2006,
        "y": 36
      },
      {
        "x": 2007,
        "y": 59
      },
      {
        "x": 2008,
        "y": 76
      },
      {
        "x": 2009,
        "y": 105
      },
      {
        "x": 2010,
        "y": 184
      },
      {
        "x": 2011,
        "y": 214
      },
      {
        "x": 2012,
        "y": 216
      },
      {
        "x": 2013,
        "y": 249
      },
      {
        "x": 2014,
        "y": 307
      }
    ]
  },
  {
    "id": "fominoben",
    "data": [
      {
        "x": 2004,
        "y": 153
      },
      {
        "x": 2005,
        "y": 286
      },
      {
        "x": 2006,
        "y": 356
      },
      {
        "x": 2007,
        "y": 356
      },
      {
        "x": 2008,
        "y": 400
      },
      {
        "x": 2009,
        "y": 460
      },
      {
        "x": 2010,
        "y": 460
      },
      {
        "x": 2011,
        "y": 460
      },
      {
        "x": 2012,
        "y": 460
      },
      {
        "x": 2013,
        "y": 460
      },
      {
        "x": 2014,
        "y": 460
      }
    ]
  },
  {
    "id": "framycetin",
    "data": [
      {
        "x": 2004,
        "y": 28
      },
      {
        "x": 2005,
        "y": 28
      },
      {
        "x": 2006,
        "y": 121
      },
      {
        "x": 2007,
        "y": 148
      },
      {
        "x": 2008,
        "y": 236
      },
      {
        "x": 2009,
        "y": 302
      },
      {
        "x": 2010,
        "y": 317
      },
      {
        "x": 2011,
        "y": 344
      },
      {
        "x": 2012,
        "y": 369
      },
      {
        "x": 2013,
        "y": 428
      },
      {
        "x": 2014,
        "y": 447
      }
    ]
  },
  {
    "id": "fusafungin",
    "data": [
      {
        "x": 2004,
        "y": 44
      },
      {
        "x": 2005,
        "y": 134
      },
      {
        "x": 2006,
        "y": 166
      },
      {
        "x": 2007,
        "y": 176
      },
      {
        "x": 2008,
        "y": 228
      },
      {
        "x": 2009,
        "y": 240
      },
      {
        "x": 2010,
        "y": 280
      },
      {
        "x": 2011,
        "y": 318
      },
      {
        "x": 2012,
        "y": 413
      },
      {
        "x": 2013,
        "y": 437
      },
      {
        "x": 2014,
        "y": 452
      }
    ]
  },
  {
    "id": "gadodiamide",
    "data": [
      {
        "x": 2004,
        "y": 299
      },
      {
        "x": 2005,
        "y": 637
      },
      {
        "x": 2006,
        "y": 1171
      },
      {
        "x": 2007,
        "y": 3209
      },
      {
        "x": 2008,
        "y": 6442
      },
      {
        "x": 2009,
        "y": 10019
      },
      {
        "x": 2010,
        "y": 21056
      },
      {
        "x": 2011,
        "y": 34314
      },
      {
        "x": 2012,
        "y": 46509
      },
      {
        "x": 2013,
        "y": 50420
      },
      {
        "x": 2014,
        "y": 55323
      }
    ]
  },
  {
    "id": "gadoversetamide",
    "data": [
      {
        "x": 2004,
        "y": 28
      },
      {
        "x": 2005,
        "y": 88
      },
      {
        "x": 2006,
        "y": 355
      },
      {
        "x": 2007,
        "y": 715
      },
      {
        "x": 2008,
        "y": 1211
      },
      {
        "x": 2009,
        "y": 3039
      },
      {
        "x": 2010,
        "y": 13294
      },
      {
        "x": 2011,
        "y": 24069
      },
      {
        "x": 2012,
        "y": 33995
      },
      {
        "x": 2013,
        "y": 36743
      },
      {
        "x": 2014,
        "y": 38102
      }
    ]
  },
  {
    "id": "gallamine",
    "data": [
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 41
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 56
      },
      {
        "x": 2013,
        "y": 178
      },
      {
        "x": 2014,
        "y": 220
      }
    ]
  },
  {
    "id": "gallopamil",
    "data": [
      {
        "x": 2004,
        "y": 1
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "gemeprost",
    "data": [
      {
        "x": 2004,
        "y": 10
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 48
      },
      {
        "x": 2011,
        "y": 82
      },
      {
        "x": 2012,
        "y": 100
      },
      {
        "x": 2013,
        "y": 125
      },
      {
        "x": 2014,
        "y": 164
      }
    ]
  },
  {
    "id": "glutathione disulfide",
    "data": [
      {
        "x": 2004,
        "y": 5
      },
      {
        "x": 2005,
        "y": 192
      },
      {
        "x": 2006,
        "y": 559
      },
      {
        "x": 2007,
        "y": 664
      },
      {
        "x": 2008,
        "y": 722
      },
      {
        "x": 2009,
        "y": 755
      },
      {
        "x": 2010,
        "y": 806
      },
      {
        "x": 2011,
        "y": 940
      },
      {
        "x": 2012,
        "y": 1092
      },
      {
        "x": 2013,
        "y": 1116
      },
      {
        "x": 2014,
        "y": 1152
      }
    ]
  },
  {
    "id": "grepafloxacin",
    "data": [
      {
        "x": 2004,
        "y": 38
      },
      {
        "x": 2005,
        "y": 44
      },
      {
        "x": 2006,
        "y": 44
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 46
      },
      {
        "x": 2009,
        "y": 54
      },
      {
        "x": 2010,
        "y": 198
      },
      {
        "x": 2011,
        "y": 340
      },
      {
        "x": 2012,
        "y": 364
      },
      {
        "x": 2013,
        "y": 404
      },
      {
        "x": 2014,
        "y": 404
      }
    ]
  },
  {
    "id": "guanethidine",
    "data": [
      {
        "x": 2004,
        "y": 35
      },
      {
        "x": 2005,
        "y": 100
      },
      {
        "x": 2006,
        "y": 136
      },
      {
        "x": 2007,
        "y": 140
      },
      {
        "x": 2008,
        "y": 144
      },
      {
        "x": 2009,
        "y": 156
      },
      {
        "x": 2010,
        "y": 167
      },
      {
        "x": 2011,
        "y": 192
      },
      {
        "x": 2012,
        "y": 203
      },
      {
        "x": 2013,
        "y": 236
      },
      {
        "x": 2014,
        "y": 236
      }
    ]
  },
  {
    "id": "halazepam",
    "data": [
      {
        "x": 2004,
        "y": 10
      },
      {
        "x": 2005,
        "y": 40
      },
      {
        "x": 2006,
        "y": 50
      },
      {
        "x": 2007,
        "y": 90
      },
      {
        "x": 2008,
        "y": 144
      },
      {
        "x": 2009,
        "y": 168
      },
      {
        "x": 2010,
        "y": 244
      },
      {
        "x": 2011,
        "y": 292
      },
      {
        "x": 2012,
        "y": 303
      },
      {
        "x": 2013,
        "y": 324
      },
      {
        "x": 2014,
        "y": 340
      }
    ]
  },
  {
    "id": "hexobendine",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 9
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "hymecromone",
    "data": [
      {
        "x": 2004,
        "y": 3
      },
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 39
      },
      {
        "x": 2007,
        "y": 48
      },
      {
        "x": 2008,
        "y": 48
      },
      {
        "x": 2009,
        "y": 54
      },
      {
        "x": 2010,
        "y": 56
      },
      {
        "x": 2011,
        "y": 56
      },
      {
        "x": 2012,
        "y": 56
      },
      {
        "x": 2013,
        "y": 56
      },
      {
        "x": 2014,
        "y": 56
      }
    ]
  },
  {
    "id": "ibutilide",
    "data": [
      {
        "x": 2004,
        "y": 36
      },
      {
        "x": 2005,
        "y": 72
      },
      {
        "x": 2006,
        "y": 79
      },
      {
        "x": 2007,
        "y": 144
      },
      {
        "x": 2008,
        "y": 172
      },
      {
        "x": 2009,
        "y": 176
      },
      {
        "x": 2010,
        "y": 184
      },
      {
        "x": 2011,
        "y": 391
      },
      {
        "x": 2012,
        "y": 489
      },
      {
        "x": 2013,
        "y": 514
      },
      {
        "x": 2014,
        "y": 540
      }
    ]
  },
  {
    "id": "idoxuridine",
    "data": [
      {
        "x": 2004,
        "y": 142
      },
      {
        "x": 2005,
        "y": 188
      },
      {
        "x": 2006,
        "y": 188
      },
      {
        "x": 2007,
        "y": 188
      },
      {
        "x": 2008,
        "y": 188
      },
      {
        "x": 2009,
        "y": 190
      },
      {
        "x": 2010,
        "y": 214
      },
      {
        "x": 2011,
        "y": 224
      },
      {
        "x": 2012,
        "y": 245
      },
      {
        "x": 2013,
        "y": 260
      },
      {
        "x": 2014,
        "y": 268
      }
    ]
  },
  {
    "id": "indium in-111 chloride",
    "data": [
      {
        "x": 2004,
        "y": 33
      },
      {
        "x": 2005,
        "y": 44
      },
      {
        "x": 2006,
        "y": 44
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "indium in-111 oxyquinoline",
    "data": [
      {
        "x": 2004,
        "y": 52
      },
      {
        "x": 2005,
        "y": 52
      },
      {
        "x": 2006,
        "y": 52
      },
      {
        "x": 2007,
        "y": 52
      },
      {
        "x": 2008,
        "y": 52
      },
      {
        "x": 2009,
        "y": 60
      },
      {
        "x": 2010,
        "y": 61
      },
      {
        "x": 2011,
        "y": 64
      },
      {
        "x": 2012,
        "y": 64
      },
      {
        "x": 2013,
        "y": 64
      },
      {
        "x": 2014,
        "y": 64
      }
    ]
  },
  {
    "id": "iotrolan",
    "data": [
      {
        "x": 2004,
        "y": 15
      },
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 53
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 100
      },
      {
        "x": 2014,
        "y": 100
      }
    ]
  },
  {
    "id": "ipriflavone",
    "data": [
      {
        "x": 2004,
        "y": 29
      },
      {
        "x": 2005,
        "y": 86
      },
      {
        "x": 2006,
        "y": 262
      },
      {
        "x": 2007,
        "y": 339
      },
      {
        "x": 2008,
        "y": 352
      },
      {
        "x": 2009,
        "y": 448
      },
      {
        "x": 2010,
        "y": 521
      },
      {
        "x": 2011,
        "y": 577
      },
      {
        "x": 2012,
        "y": 725
      },
      {
        "x": 2013,
        "y": 740
      },
      {
        "x": 2014,
        "y": 759
      }
    ]
  },
  {
    "id": "isoetharine",
    "data": [
      {
        "x": 2004,
        "y": 7
      },
      {
        "x": 2005,
        "y": 52
      },
      {
        "x": 2006,
        "y": 81
      },
      {
        "x": 2007,
        "y": 132
      },
      {
        "x": 2008,
        "y": 182
      },
      {
        "x": 2009,
        "y": 262
      },
      {
        "x": 2010,
        "y": 331
      },
      {
        "x": 2011,
        "y": 407
      },
      {
        "x": 2012,
        "y": 453
      },
      {
        "x": 2013,
        "y": 488
      },
      {
        "x": 2014,
        "y": 488
      }
    ]
  },
  {
    "id": "isoleucine",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 24
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 48
      },
      {
        "x": 2011,
        "y": 54
      },
      {
        "x": 2012,
        "y": 84
      },
      {
        "x": 2013,
        "y": 87
      },
      {
        "x": 2014,
        "y": 97
      }
    ]
  },
  {
    "id": "isothipendyl",
    "data": [
      {
        "x": 2004,
        "y": 18
      },
      {
        "x": 2005,
        "y": 36
      },
      {
        "x": 2006,
        "y": 36
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 36
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "kaolin",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 159
      },
      {
        "x": 2006,
        "y": 232
      },
      {
        "x": 2007,
        "y": 241
      },
      {
        "x": 2008,
        "y": 268
      },
      {
        "x": 2009,
        "y": 271
      },
      {
        "x": 2010,
        "y": 346
      },
      {
        "x": 2011,
        "y": 348
      },
      {
        "x": 2012,
        "y": 350
      },
      {
        "x": 2013,
        "y": 356
      },
      {
        "x": 2014,
        "y": 439
      }
    ]
  },
  {
    "id": "leucine",
    "data": [
      {
        "x": 2004,
        "y": 49
      },
      {
        "x": 2005,
        "y": 108
      },
      {
        "x": 2006,
        "y": 108
      },
      {
        "x": 2007,
        "y": 148
      },
      {
        "x": 2008,
        "y": 148
      },
      {
        "x": 2009,
        "y": 164
      },
      {
        "x": 2010,
        "y": 176
      },
      {
        "x": 2011,
        "y": 203
      },
      {
        "x": 2012,
        "y": 220
      },
      {
        "x": 2013,
        "y": 262
      },
      {
        "x": 2014,
        "y": 395
      }
    ]
  },
  {
    "id": "levallorphan",
    "data": [
      {
        "x": 2004,
        "y": 28
      },
      {
        "x": 2005,
        "y": 48
      },
      {
        "x": 2006,
        "y": 48
      },
      {
        "x": 2007,
        "y": 48
      },
      {
        "x": 2008,
        "y": 48
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 48
      },
      {
        "x": 2011,
        "y": 48
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 48
      },
      {
        "x": 2014,
        "y": 48
      }
    ]
  },
  {
    "id": "lodoxamide",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 198
      },
      {
        "x": 2007,
        "y": 256
      },
      {
        "x": 2008,
        "y": 268
      },
      {
        "x": 2009,
        "y": 268
      },
      {
        "x": 2010,
        "y": 268
      },
      {
        "x": 2011,
        "y": 300
      },
      {
        "x": 2012,
        "y": 352
      },
      {
        "x": 2013,
        "y": 385
      },
      {
        "x": 2014,
        "y": 469
      }
    ]
  },
  {
    "id": "lofexidine",
    "data": [
      {
        "x": 2004,
        "y": 14
      },
      {
        "x": 2005,
        "y": 96
      },
      {
        "x": 2006,
        "y": 96
      },
      {
        "x": 2007,
        "y": 96
      },
      {
        "x": 2008,
        "y": 96
      },
      {
        "x": 2009,
        "y": 96
      },
      {
        "x": 2010,
        "y": 96
      },
      {
        "x": 2011,
        "y": 98
      },
      {
        "x": 2012,
        "y": 108
      },
      {
        "x": 2013,
        "y": 126
      },
      {
        "x": 2014,
        "y": 134
      }
    ]
  },
  {
    "id": "mafenide",
    "data": [
      {
        "x": 2004,
        "y": 8
      },
      {
        "x": 2005,
        "y": 19
      },
      {
        "x": 2006,
        "y": 42
      },
      {
        "x": 2007,
        "y": 84
      },
      {
        "x": 2008,
        "y": 88
      },
      {
        "x": 2009,
        "y": 92
      },
      {
        "x": 2010,
        "y": 97
      },
      {
        "x": 2011,
        "y": 100
      },
      {
        "x": 2012,
        "y": 107
      },
      {
        "x": 2013,
        "y": 112
      },
      {
        "x": 2014,
        "y": 136
      }
    ]
  },
  {
    "id": "magnesium orotate",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 24
      },
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 56
      },
      {
        "x": 2008,
        "y": 72
      },
      {
        "x": 2009,
        "y": 82
      },
      {
        "x": 2010,
        "y": 104
      },
      {
        "x": 2011,
        "y": 104
      },
      {
        "x": 2012,
        "y": 122
      },
      {
        "x": 2013,
        "y": 131
      },
      {
        "x": 2014,
        "y": 140
      }
    ]
  },
  {
    "id": "magnesium silicate",
    "data": [
      {
        "x": 2004,
        "y": 15
      },
      {
        "x": 2005,
        "y": 66
      },
      {
        "x": 2006,
        "y": 72
      },
      {
        "x": 2007,
        "y": 72
      },
      {
        "x": 2008,
        "y": 73
      },
      {
        "x": 2009,
        "y": 80
      },
      {
        "x": 2010,
        "y": 105
      },
      {
        "x": 2011,
        "y": 182
      },
      {
        "x": 2012,
        "y": 184
      },
      {
        "x": 2013,
        "y": 192
      },
      {
        "x": 2014,
        "y": 231
      }
    ]
  },
  {
    "id": "meclocycline",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 24
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 48
      },
      {
        "x": 2008,
        "y": 56
      },
      {
        "x": 2009,
        "y": 56
      },
      {
        "x": 2010,
        "y": 56
      },
      {
        "x": 2011,
        "y": 250
      },
      {
        "x": 2012,
        "y": 456
      },
      {
        "x": 2013,
        "y": 456
      },
      {
        "x": 2014,
        "y": 456
      }
    ]
  },
  {
    "id": "meclofenoxate",
    "data": [
      {
        "x": 2004,
        "y": 7
      },
      {
        "x": 2005,
        "y": 56
      },
      {
        "x": 2006,
        "y": 56
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 64
      },
      {
        "x": 2009,
        "y": 68
      },
      {
        "x": 2010,
        "y": 72
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 109
      },
      {
        "x": 2013,
        "y": 155
      },
      {
        "x": 2014,
        "y": 195
      }
    ]
  },
  {
    "id": "medrogestone",
    "data": [
      {
        "x": 2004,
        "y": 23
      },
      {
        "x": 2005,
        "y": 60
      },
      {
        "x": 2006,
        "y": 60
      },
      {
        "x": 2007,
        "y": 66
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 69
      },
      {
        "x": 2010,
        "y": 72
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 72
      },
      {
        "x": 2013,
        "y": 111
      },
      {
        "x": 2014,
        "y": 143
      }
    ]
  },
  {
    "id": "mepindolol",
    "data": [
      {
        "x": 2004,
        "y": 71
      },
      {
        "x": 2005,
        "y": 124
      },
      {
        "x": 2006,
        "y": 124
      },
      {
        "x": 2007,
        "y": 124
      },
      {
        "x": 2008,
        "y": 124
      },
      {
        "x": 2009,
        "y": 124
      },
      {
        "x": 2010,
        "y": 124
      },
      {
        "x": 2011,
        "y": 124
      },
      {
        "x": 2012,
        "y": 124
      },
      {
        "x": 2013,
        "y": 124
      },
      {
        "x": 2014,
        "y": 124
      }
    ]
  },
  {
    "id": "mesoridazine",
    "data": [
      {
        "x": 2004,
        "y": 41
      },
      {
        "x": 2005,
        "y": 192
      },
      {
        "x": 2006,
        "y": 375
      },
      {
        "x": 2007,
        "y": 548
      },
      {
        "x": 2008,
        "y": 621
      },
      {
        "x": 2009,
        "y": 745
      },
      {
        "x": 2010,
        "y": 827
      },
      {
        "x": 2011,
        "y": 880
      },
      {
        "x": 2012,
        "y": 889
      },
      {
        "x": 2013,
        "y": 906
      },
      {
        "x": 2014,
        "y": 933
      }
    ]
  },
  {
    "id": "mestranol",
    "data": [
      {
        "x": 2004,
        "y": 28
      },
      {
        "x": 2005,
        "y": 104
      },
      {
        "x": 2006,
        "y": 153
      },
      {
        "x": 2007,
        "y": 200
      },
      {
        "x": 2008,
        "y": 200
      },
      {
        "x": 2009,
        "y": 209
      },
      {
        "x": 2010,
        "y": 212
      },
      {
        "x": 2011,
        "y": 212
      },
      {
        "x": 2012,
        "y": 284
      },
      {
        "x": 2013,
        "y": 312
      },
      {
        "x": 2014,
        "y": 314
      }
    ]
  },
  {
    "id": "methacholine",
    "data": [
      {
        "x": 2004,
        "y": 8
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 46
      },
      {
        "x": 2009,
        "y": 73
      },
      {
        "x": 2010,
        "y": 101
      },
      {
        "x": 2011,
        "y": 341
      },
      {
        "x": 2012,
        "y": 752
      },
      {
        "x": 2013,
        "y": 1218
      },
      {
        "x": 2014,
        "y": 1250
      }
    ]
  },
  {
    "id": "methadyl acetate",
    "data": [
      {
        "x": 2004,
        "y": 52
      },
      {
        "x": 2005,
        "y": 58
      },
      {
        "x": 2006,
        "y": 60
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 60
      },
      {
        "x": 2009,
        "y": 60
      },
      {
        "x": 2010,
        "y": 60
      },
      {
        "x": 2011,
        "y": 60
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "methandrostenolone",
    "data": [
      {
        "x": 2004,
        "y": 1
      },
      {
        "x": 2005,
        "y": 159
      },
      {
        "x": 2006,
        "y": 304
      },
      {
        "x": 2007,
        "y": 306
      },
      {
        "x": 2008,
        "y": 334
      },
      {
        "x": 2009,
        "y": 364
      },
      {
        "x": 2010,
        "y": 388
      },
      {
        "x": 2011,
        "y": 424
      },
      {
        "x": 2012,
        "y": 488
      },
      {
        "x": 2013,
        "y": 627
      },
      {
        "x": 2014,
        "y": 681
      }
    ]
  },
  {
    "id": "methapyrilene",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "methaqualone",
    "data": [
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 38
      },
      {
        "x": 2006,
        "y": 53
      },
      {
        "x": 2007,
        "y": 56
      },
      {
        "x": 2008,
        "y": 56
      },
      {
        "x": 2009,
        "y": 56
      },
      {
        "x": 2010,
        "y": 56
      },
      {
        "x": 2011,
        "y": 66
      },
      {
        "x": 2012,
        "y": 399
      },
      {
        "x": 2013,
        "y": 528
      },
      {
        "x": 2014,
        "y": 555
      }
    ]
  },
  {
    "id": "methoxamine",
    "data": [
      {
        "x": 2004,
        "y": 8
      },
      {
        "x": 2005,
        "y": 28
      },
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 43
      },
      {
        "x": 2008,
        "y": 88
      },
      {
        "x": 2009,
        "y": 156
      },
      {
        "x": 2010,
        "y": 158
      },
      {
        "x": 2011,
        "y": 249
      },
      {
        "x": 2012,
        "y": 412
      },
      {
        "x": 2013,
        "y": 421
      },
      {
        "x": 2014,
        "y": 464
      }
    ]
  },
  {
    "id": "methoxyflurane",
    "data": [
      {
        "x": 2004,
        "y": 34
      },
      {
        "x": 2005,
        "y": 68
      },
      {
        "x": 2006,
        "y": 68
      },
      {
        "x": 2007,
        "y": 68
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 68
      },
      {
        "x": 2010,
        "y": 68
      },
      {
        "x": 2011,
        "y": 71
      },
      {
        "x": 2012,
        "y": 72
      },
      {
        "x": 2013,
        "y": 73
      },
      {
        "x": 2014,
        "y": 103
      }
    ]
  },
  {
    "id": "methylparaben",
    "data": [
      {
        "x": 2004,
        "y": 24
      },
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 50
      },
      {
        "x": 2013,
        "y": 68
      },
      {
        "x": 2014,
        "y": 68
      }
    ]
  },
  {
    "id": "metipranolol",
    "data": [
      {
        "x": 2004,
        "y": 7
      },
      {
        "x": 2005,
        "y": 175
      },
      {
        "x": 2006,
        "y": 268
      },
      {
        "x": 2007,
        "y": 328
      },
      {
        "x": 2008,
        "y": 346
      },
      {
        "x": 2009,
        "y": 401
      },
      {
        "x": 2010,
        "y": 491
      },
      {
        "x": 2011,
        "y": 712
      },
      {
        "x": 2012,
        "y": 733
      },
      {
        "x": 2013,
        "y": 748
      },
      {
        "x": 2014,
        "y": 774
      }
    ]
  },
  {
    "id": "mezlocillin",
    "data": [
      {
        "x": 2004,
        "y": 15
      },
      {
        "x": 2005,
        "y": 53
      },
      {
        "x": 2006,
        "y": 89
      },
      {
        "x": 2007,
        "y": 113
      },
      {
        "x": 2008,
        "y": 132
      },
      {
        "x": 2009,
        "y": 136
      },
      {
        "x": 2010,
        "y": 151
      },
      {
        "x": 2011,
        "y": 163
      },
      {
        "x": 2012,
        "y": 246
      },
      {
        "x": 2013,
        "y": 265
      },
      {
        "x": 2014,
        "y": 295
      }
    ]
  },
  {
    "id": "mibefradil",
    "data": [
      {
        "x": 2004,
        "y": 169
      },
      {
        "x": 2005,
        "y": 524
      },
      {
        "x": 2006,
        "y": 524
      },
      {
        "x": 2007,
        "y": 524
      },
      {
        "x": 2008,
        "y": 524
      },
      {
        "x": 2009,
        "y": 530
      },
      {
        "x": 2010,
        "y": 532
      },
      {
        "x": 2011,
        "y": 532
      },
      {
        "x": 2012,
        "y": 532
      },
      {
        "x": 2013,
        "y": 536
      },
      {
        "x": 2014,
        "y": 540
      }
    ]
  },
  {
    "id": "micronomicin",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "midecamycin",
    "data": [
      {
        "x": 2004,
        "y": 27
      },
      {
        "x": 2005,
        "y": 36
      },
      {
        "x": 2006,
        "y": 36
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 72
      },
      {
        "x": 2009,
        "y": 87
      },
      {
        "x": 2010,
        "y": 88
      },
      {
        "x": 2011,
        "y": 88
      },
      {
        "x": 2012,
        "y": 88
      },
      {
        "x": 2013,
        "y": 88
      },
      {
        "x": 2014,
        "y": 88
      }
    ]
  },
  {
    "id": "moxaverine",
    "data": [
      {
        "x": 2004,
        "y": 8
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "moxisylyte",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 28
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 52
      }
    ]
  },
  {
    "id": "nifuratel",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 9
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 91
      }
    ]
  },
  {
    "id": "nonoxynol-9",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 7
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 49
      },
      {
        "x": 2011,
        "y": 83
      },
      {
        "x": 2012,
        "y": 148
      },
      {
        "x": 2013,
        "y": 172
      },
      {
        "x": 2014,
        "y": 186
      }
    ]
  },
  {
    "id": "norethandrolone",
    "data": [
      {
        "x": 2004,
        "y": 28
      },
      {
        "x": 2005,
        "y": 64
      },
      {
        "x": 2006,
        "y": 70
      },
      {
        "x": 2007,
        "y": 100
      },
      {
        "x": 2008,
        "y": 112
      },
      {
        "x": 2009,
        "y": 115
      },
      {
        "x": 2010,
        "y": 124
      },
      {
        "x": 2011,
        "y": 126
      },
      {
        "x": 2012,
        "y": 214
      },
      {
        "x": 2013,
        "y": 260
      },
      {
        "x": 2014,
        "y": 301
      }
    ]
  },
  {
    "id": "norflurane",
    "data": [
      {
        "x": 2004,
        "y": 38
      },
      {
        "x": 2005,
        "y": 76
      },
      {
        "x": 2006,
        "y": 76
      },
      {
        "x": 2007,
        "y": 76
      },
      {
        "x": 2008,
        "y": 76
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 76
      },
      {
        "x": 2011,
        "y": 76
      },
      {
        "x": 2012,
        "y": 76
      },
      {
        "x": 2013,
        "y": 76
      },
      {
        "x": 2014,
        "y": 91
      }
    ]
  },
  {
    "id": "oxtriphylline",
    "data": [
      {
        "x": 2004,
        "y": 11
      },
      {
        "x": 2005,
        "y": 36
      },
      {
        "x": 2006,
        "y": 45
      },
      {
        "x": 2007,
        "y": 72
      },
      {
        "x": 2008,
        "y": 72
      },
      {
        "x": 2009,
        "y": 72
      },
      {
        "x": 2010,
        "y": 72
      },
      {
        "x": 2011,
        "y": 114
      },
      {
        "x": 2012,
        "y": 325
      },
      {
        "x": 2013,
        "y": 580
      },
      {
        "x": 2014,
        "y": 582
      }
    ]
  },
  {
    "id": "oxypertine",
    "data": [
      {
        "x": 2004,
        "y": 24
      },
      {
        "x": 2005,
        "y": 52
      },
      {
        "x": 2006,
        "y": 61
      },
      {
        "x": 2007,
        "y": 64
      },
      {
        "x": 2008,
        "y": 64
      },
      {
        "x": 2009,
        "y": 69
      },
      {
        "x": 2010,
        "y": 79
      },
      {
        "x": 2011,
        "y": 93
      },
      {
        "x": 2012,
        "y": 154
      },
      {
        "x": 2013,
        "y": 188
      },
      {
        "x": 2014,
        "y": 190
      }
    ]
  },
  {
    "id": "oxyphenbutazone",
    "data": [
      {
        "x": 2004,
        "y": 26
      },
      {
        "x": 2005,
        "y": 72
      },
      {
        "x": 2006,
        "y": 72
      },
      {
        "x": 2007,
        "y": 72
      },
      {
        "x": 2008,
        "y": 72
      },
      {
        "x": 2009,
        "y": 72
      },
      {
        "x": 2010,
        "y": 74
      },
      {
        "x": 2011,
        "y": 76
      },
      {
        "x": 2012,
        "y": 120
      },
      {
        "x": 2013,
        "y": 120
      },
      {
        "x": 2014,
        "y": 120
      }
    ]
  },
  {
    "id": "oxyphenonium",
    "data": [
      {
        "x": 2004,
        "y": 228
      },
      {
        "x": 2005,
        "y": 228
      },
      {
        "x": 2006,
        "y": 228
      },
      {
        "x": 2007,
        "y": 228
      },
      {
        "x": 2008,
        "y": 228
      },
      {
        "x": 2009,
        "y": 228
      },
      {
        "x": 2010,
        "y": 228
      },
      {
        "x": 2011,
        "y": 228
      },
      {
        "x": 2012,
        "y": 228
      },
      {
        "x": 2013,
        "y": 228
      },
      {
        "x": 2014,
        "y": 228
      }
    ]
  },
  {
    "id": "pefloxacin",
    "data": [
      {
        "x": 2004,
        "y": 14
      },
      {
        "x": 2005,
        "y": 78
      },
      {
        "x": 2006,
        "y": 88
      },
      {
        "x": 2007,
        "y": 118
      },
      {
        "x": 2008,
        "y": 255
      },
      {
        "x": 2009,
        "y": 304
      },
      {
        "x": 2010,
        "y": 312
      },
      {
        "x": 2011,
        "y": 371
      },
      {
        "x": 2012,
        "y": 388
      },
      {
        "x": 2013,
        "y": 390
      },
      {
        "x": 2014,
        "y": 400
      }
    ]
  },
  {
    "id": "phenazocine",
    "data": [
      {
        "x": 2004,
        "y": 21
      },
      {
        "x": 2005,
        "y": 60
      },
      {
        "x": 2006,
        "y": 60
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 60
      },
      {
        "x": 2009,
        "y": 61
      },
      {
        "x": 2010,
        "y": 74
      },
      {
        "x": 2011,
        "y": 84
      },
      {
        "x": 2012,
        "y": 84
      },
      {
        "x": 2013,
        "y": 84
      },
      {
        "x": 2014,
        "y": 84
      }
    ]
  },
  {
    "id": "phenethicillin",
    "data": [
      {
        "x": 2004,
        "y": 26
      },
      {
        "x": 2005,
        "y": 52
      },
      {
        "x": 2006,
        "y": 57
      },
      {
        "x": 2007,
        "y": 64
      },
      {
        "x": 2008,
        "y": 67
      },
      {
        "x": 2009,
        "y": 80
      },
      {
        "x": 2010,
        "y": 92
      },
      {
        "x": 2011,
        "y": 118
      },
      {
        "x": 2012,
        "y": 124
      },
      {
        "x": 2013,
        "y": 133
      },
      {
        "x": 2014,
        "y": 151
      }
    ]
  },
  {
    "id": "phenethylamine",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 14
      },
      {
        "x": 2010,
        "y": 34
      },
      {
        "x": 2011,
        "y": 55
      },
      {
        "x": 2012,
        "y": 112
      },
      {
        "x": 2013,
        "y": 120
      },
      {
        "x": 2014,
        "y": 120
      }
    ]
  },
  {
    "id": "phenformin",
    "data": [
      {
        "x": 2004,
        "y": 9
      },
      {
        "x": 2005,
        "y": 28
      },
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 74
      },
      {
        "x": 2013,
        "y": 94
      },
      {
        "x": 2014,
        "y": 100
      }
    ]
  },
  {
    "id": "phenyl salicylate",
    "data": [
      {
        "x": 2004,
        "y": 169
      },
      {
        "x": 2005,
        "y": 488
      },
      {
        "x": 2006,
        "y": 769
      },
      {
        "x": 2007,
        "y": 860
      },
      {
        "x": 2008,
        "y": 1052
      },
      {
        "x": 2009,
        "y": 1251
      },
      {
        "x": 2010,
        "y": 1418
      },
      {
        "x": 2011,
        "y": 1830
      },
      {
        "x": 2012,
        "y": 2210
      },
      {
        "x": 2013,
        "y": 2365
      },
      {
        "x": 2014,
        "y": 2737
      }
    ]
  },
  {
    "id": "phenyltoloxamine",
    "data": [
      {
        "x": 2004,
        "y": 108
      },
      {
        "x": 2005,
        "y": 373
      },
      {
        "x": 2006,
        "y": 568
      },
      {
        "x": 2007,
        "y": 640
      },
      {
        "x": 2008,
        "y": 685
      },
      {
        "x": 2009,
        "y": 761
      },
      {
        "x": 2010,
        "y": 802
      },
      {
        "x": 2011,
        "y": 829
      },
      {
        "x": 2012,
        "y": 841
      },
      {
        "x": 2013,
        "y": 932
      },
      {
        "x": 2014,
        "y": 961
      }
    ]
  },
  {
    "id": "phosphatidylserine",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 87
      },
      {
        "x": 2011,
        "y": 122
      },
      {
        "x": 2012,
        "y": 158
      },
      {
        "x": 2013,
        "y": 264
      },
      {
        "x": 2014,
        "y": 395
      }
    ]
  },
  {
    "id": "phosphorus 32",
    "data": [
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 64
      },
      {
        "x": 2006,
        "y": 64
      },
      {
        "x": 2007,
        "y": 64
      },
      {
        "x": 2008,
        "y": 73
      },
      {
        "x": 2009,
        "y": 135
      },
      {
        "x": 2010,
        "y": 210
      },
      {
        "x": 2011,
        "y": 220
      },
      {
        "x": 2012,
        "y": 265
      },
      {
        "x": 2013,
        "y": 284
      },
      {
        "x": 2014,
        "y": 304
      }
    ]
  },
  {
    "id": "pipecuronium",
    "data": [
      {
        "x": 2004,
        "y": 10
      },
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 22
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 30
      },
      {
        "x": 2010,
        "y": 40
      },
      {
        "x": 2011,
        "y": 42
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 160
      },
      {
        "x": 2014,
        "y": 232
      }
    ]
  },
  {
    "id": "pivampicillin",
    "data": [
      {
        "x": 2004,
        "y": 13
      },
      {
        "x": 2005,
        "y": 99
      },
      {
        "x": 2006,
        "y": 143
      },
      {
        "x": 2007,
        "y": 246
      },
      {
        "x": 2008,
        "y": 260
      },
      {
        "x": 2009,
        "y": 268
      },
      {
        "x": 2010,
        "y": 301
      },
      {
        "x": 2011,
        "y": 332
      },
      {
        "x": 2012,
        "y": 377
      },
      {
        "x": 2013,
        "y": 408
      },
      {
        "x": 2014,
        "y": 467
      }
    ]
  },
  {
    "id": "polythiazide",
    "data": [
      {
        "x": 2004,
        "y": 24
      },
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 48
      },
      {
        "x": 2011,
        "y": 50
      },
      {
        "x": 2012,
        "y": 53
      },
      {
        "x": 2013,
        "y": 56
      },
      {
        "x": 2014,
        "y": 56
      }
    ]
  },
  {
    "id": "potassium iodate",
    "data": [
      {
        "x": 2004,
        "y": 14
      },
      {
        "x": 2005,
        "y": 56
      },
      {
        "x": 2006,
        "y": 56
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 60
      },
      {
        "x": 2009,
        "y": 60
      },
      {
        "x": 2010,
        "y": 75
      },
      {
        "x": 2011,
        "y": 80
      },
      {
        "x": 2012,
        "y": 80
      },
      {
        "x": 2013,
        "y": 80
      },
      {
        "x": 2014,
        "y": 106
      }
    ]
  },
  {
    "id": "pralidoxime",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 41
      },
      {
        "x": 2007,
        "y": 56
      },
      {
        "x": 2008,
        "y": 60
      },
      {
        "x": 2009,
        "y": 60
      },
      {
        "x": 2010,
        "y": 64
      },
      {
        "x": 2011,
        "y": 127
      },
      {
        "x": 2012,
        "y": 150
      },
      {
        "x": 2013,
        "y": 191
      },
      {
        "x": 2014,
        "y": 288
      }
    ]
  },
  {
    "id": "pridinol",
    "data": [
      {
        "x": 2004,
        "y": 44
      },
      {
        "x": 2005,
        "y": 116
      },
      {
        "x": 2006,
        "y": 164
      },
      {
        "x": 2007,
        "y": 218
      },
      {
        "x": 2008,
        "y": 271
      },
      {
        "x": 2009,
        "y": 304
      },
      {
        "x": 2010,
        "y": 337
      },
      {
        "x": 2011,
        "y": 340
      },
      {
        "x": 2012,
        "y": 392
      },
      {
        "x": 2013,
        "y": 400
      },
      {
        "x": 2014,
        "y": 403
      }
    ]
  },
  {
    "id": "proline",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 17
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 48
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 48
      },
      {
        "x": 2014,
        "y": 64
      }
    ]
  },
  {
    "id": "propamidine",
    "data": [
      {
        "x": 2004,
        "y": 18
      },
      {
        "x": 2005,
        "y": 27
      },
      {
        "x": 2006,
        "y": 28
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 36
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 83
      },
      {
        "x": 2011,
        "y": 124
      },
      {
        "x": 2012,
        "y": 140
      },
      {
        "x": 2013,
        "y": 155
      },
      {
        "x": 2014,
        "y": 161
      }
    ]
  },
  {
    "id": "propicillin",
    "data": [
      {
        "x": 2004,
        "y": 12
      },
      {
        "x": 2005,
        "y": 24
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "propyliodone",
    "data": [
      {
        "x": 2004,
        "y": 8
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "quinestrol",
    "data": [
      {
        "x": 2004,
        "y": 12
      },
      {
        "x": 2005,
        "y": 24
      },
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 40
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 40
      },
      {
        "x": 2011,
        "y": 40
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "ruscogenin",
    "data": [
      {
        "x": 2004,
        "y": 20
      },
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 38
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 50
      },
      {
        "x": 2012,
        "y": 68
      },
      {
        "x": 2013,
        "y": 68
      },
      {
        "x": 2014,
        "y": 68
      }
    ]
  },
  {
    "id": "silicon dioxide, colloidal",
    "data": [
      {
        "x": 2004,
        "y": 33
      },
      {
        "x": 2005,
        "y": 62
      },
      {
        "x": 2006,
        "y": 80
      },
      {
        "x": 2007,
        "y": 80
      },
      {
        "x": 2008,
        "y": 80
      },
      {
        "x": 2009,
        "y": 80
      },
      {
        "x": 2010,
        "y": 86
      },
      {
        "x": 2011,
        "y": 92
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 108
      },
      {
        "x": 2014,
        "y": 111
      }
    ]
  },
  {
    "id": "sodium stibogluconate",
    "data": [
      {
        "x": 2004,
        "y": 4
      },
      {
        "x": 2005,
        "y": 56
      },
      {
        "x": 2006,
        "y": 75
      },
      {
        "x": 2007,
        "y": 96
      },
      {
        "x": 2008,
        "y": 108
      },
      {
        "x": 2009,
        "y": 164
      },
      {
        "x": 2010,
        "y": 277
      },
      {
        "x": 2011,
        "y": 296
      },
      {
        "x": 2012,
        "y": 299
      },
      {
        "x": 2013,
        "y": 308
      },
      {
        "x": 2014,
        "y": 327
      }
    ]
  },
  {
    "id": "sparfloxacin",
    "data": [
      {
        "x": 2004,
        "y": 200
      },
      {
        "x": 2005,
        "y": 375
      },
      {
        "x": 2006,
        "y": 428
      },
      {
        "x": 2007,
        "y": 470
      },
      {
        "x": 2008,
        "y": 538
      },
      {
        "x": 2009,
        "y": 612
      },
      {
        "x": 2010,
        "y": 642
      },
      {
        "x": 2011,
        "y": 662
      },
      {
        "x": 2012,
        "y": 707
      },
      {
        "x": 2013,
        "y": 720
      },
      {
        "x": 2014,
        "y": 722
      }
    ]
  },
  {
    "id": "spectinomycin",
    "data": [
      {
        "x": 2004,
        "y": 20
      },
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 21
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "sulfuric acid",
    "data": [
      {
        "x": 2004,
        "y": 30
      },
      {
        "x": 2005,
        "y": 44
      },
      {
        "x": 2006,
        "y": 56
      },
      {
        "x": 2007,
        "y": 56
      },
      {
        "x": 2008,
        "y": 62
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 76
      },
      {
        "x": 2011,
        "y": 78
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 99
      },
      {
        "x": 2014,
        "y": 184
      }
    ]
  },
  {
    "id": "synephrine",
    "data": [
      {
        "x": 2004,
        "y": 10
      },
      {
        "x": 2005,
        "y": 28
      },
      {
        "x": 2006,
        "y": 28
      },
      {
        "x": 2007,
        "y": 69
      },
      {
        "x": 2008,
        "y": 84
      },
      {
        "x": 2009,
        "y": 84
      },
      {
        "x": 2010,
        "y": 84
      },
      {
        "x": 2011,
        "y": 93
      },
      {
        "x": 2012,
        "y": 97
      },
      {
        "x": 2013,
        "y": 112
      },
      {
        "x": 2014,
        "y": 148
      }
    ]
  },
  {
    "id": "tacrine",
    "data": [
      {
        "x": 2004,
        "y": 28
      },
      {
        "x": 2005,
        "y": 36
      },
      {
        "x": 2006,
        "y": 144
      },
      {
        "x": 2007,
        "y": 144
      },
      {
        "x": 2008,
        "y": 168
      },
      {
        "x": 2009,
        "y": 172
      },
      {
        "x": 2010,
        "y": 172
      },
      {
        "x": 2011,
        "y": 173
      },
      {
        "x": 2012,
        "y": 233
      },
      {
        "x": 2013,
        "y": 253
      },
      {
        "x": 2014,
        "y": 256
      }
    ]
  },
  {
    "id": "talinolol",
    "data": [
      {
        "x": 2004,
        "y": 60
      },
      {
        "x": 2005,
        "y": 81
      },
      {
        "x": 2006,
        "y": 116
      },
      {
        "x": 2007,
        "y": 161
      },
      {
        "x": 2008,
        "y": 184
      },
      {
        "x": 2009,
        "y": 219
      },
      {
        "x": 2010,
        "y": 312
      },
      {
        "x": 2011,
        "y": 434
      },
      {
        "x": 2012,
        "y": 547
      },
      {
        "x": 2013,
        "y": 611
      },
      {
        "x": 2014,
        "y": 682
      }
    ]
  },
  {
    "id": "tannic acid",
    "data": [
      {
        "x": 2004,
        "y": 31
      },
      {
        "x": 2005,
        "y": 52
      },
      {
        "x": 2006,
        "y": 52
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 68
      },
      {
        "x": 2010,
        "y": 177
      },
      {
        "x": 2011,
        "y": 490
      },
      {
        "x": 2012,
        "y": 656
      },
      {
        "x": 2013,
        "y": 956
      },
      {
        "x": 2014,
        "y": 961
      }
    ]
  },
  {
    "id": "technetium tc 99m medronate",
    "data": [
      {
        "x": 2004,
        "y": 3
      },
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 15
      },
      {
        "x": 2014,
        "y": 30
      }
    ]
  },
  {
    "id": "testolactone",
    "data": [
      {
        "x": 2004,
        "y": 19
      },
      {
        "x": 2005,
        "y": 30
      },
      {
        "x": 2006,
        "y": 36
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 36
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "tiratricol",
    "data": [
      {
        "x": 2004,
        "y": 12
      },
      {
        "x": 2005,
        "y": 52
      },
      {
        "x": 2006,
        "y": 82
      },
      {
        "x": 2007,
        "y": 95
      },
      {
        "x": 2008,
        "y": 96
      },
      {
        "x": 2009,
        "y": 96
      },
      {
        "x": 2010,
        "y": 100
      },
      {
        "x": 2011,
        "y": 104
      },
      {
        "x": 2012,
        "y": 104
      },
      {
        "x": 2013,
        "y": 121
      },
      {
        "x": 2014,
        "y": 208
      }
    ]
  },
  {
    "id": "titanium dioxide",
    "data": [
      {
        "x": 2004,
        "y": 24
      },
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 64
      },
      {
        "x": 2014,
        "y": 76
      }
    ]
  },
  {
    "id": "trepibutone",
    "data": [
      {
        "x": 2004,
        "y": 20
      },
      {
        "x": 2005,
        "y": 83
      },
      {
        "x": 2006,
        "y": 84
      },
      {
        "x": 2007,
        "y": 117
      },
      {
        "x": 2008,
        "y": 252
      },
      {
        "x": 2009,
        "y": 288
      },
      {
        "x": 2010,
        "y": 288
      },
      {
        "x": 2011,
        "y": 288
      },
      {
        "x": 2012,
        "y": 288
      },
      {
        "x": 2013,
        "y": 288
      },
      {
        "x": 2014,
        "y": 288
      }
    ]
  },
  {
    "id": "tribenoside",
    "data": [
      {
        "x": 2004,
        "y": 18
      },
      {
        "x": 2005,
        "y": 29
      },
      {
        "x": 2006,
        "y": 88
      },
      {
        "x": 2007,
        "y": 99
      },
      {
        "x": 2008,
        "y": 110
      },
      {
        "x": 2009,
        "y": 137
      },
      {
        "x": 2010,
        "y": 204
      },
      {
        "x": 2011,
        "y": 256
      },
      {
        "x": 2012,
        "y": 346
      },
      {
        "x": 2013,
        "y": 441
      },
      {
        "x": 2014,
        "y": 472
      }
    ]
  },
  {
    "id": "triclocarban",
    "data": [
      {
        "x": 2004,
        "y": 8
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 30
      },
      {
        "x": 2014,
        "y": 47
      }
    ]
  },
  {
    "id": "triflupromazine",
    "data": [
      {
        "x": 2004,
        "y": 48
      },
      {
        "x": 2005,
        "y": 84
      },
      {
        "x": 2006,
        "y": 141
      },
      {
        "x": 2007,
        "y": 148
      },
      {
        "x": 2008,
        "y": 148
      },
      {
        "x": 2009,
        "y": 148
      },
      {
        "x": 2010,
        "y": 150
      },
      {
        "x": 2011,
        "y": 156
      },
      {
        "x": 2012,
        "y": 156
      },
      {
        "x": 2013,
        "y": 156
      },
      {
        "x": 2014,
        "y": 156
      }
    ]
  },
  {
    "id": "trilostane",
    "data": [
      {
        "x": 2004,
        "y": 28
      },
      {
        "x": 2005,
        "y": 54
      },
      {
        "x": 2006,
        "y": 68
      },
      {
        "x": 2007,
        "y": 68
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 68
      },
      {
        "x": 2010,
        "y": 68
      },
      {
        "x": 2011,
        "y": 68
      },
      {
        "x": 2012,
        "y": 68
      },
      {
        "x": 2013,
        "y": 68
      },
      {
        "x": 2014,
        "y": 68
      }
    ]
  },
  {
    "id": "trimethadione",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 26
      },
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 40
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 54
      },
      {
        "x": 2011,
        "y": 126
      },
      {
        "x": 2012,
        "y": 190
      },
      {
        "x": 2013,
        "y": 242
      },
      {
        "x": 2014,
        "y": 280
      }
    ]
  },
  {
    "id": "troleandomycin",
    "data": [
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 76
      },
      {
        "x": 2006,
        "y": 76
      },
      {
        "x": 2007,
        "y": 76
      },
      {
        "x": 2008,
        "y": 76
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 76
      },
      {
        "x": 2011,
        "y": 79
      },
      {
        "x": 2012,
        "y": 82
      },
      {
        "x": 2013,
        "y": 88
      },
      {
        "x": 2014,
        "y": 91
      }
    ]
  },
  {
    "id": "trovafloxacin",
    "data": [
      {
        "x": 2004,
        "y": 324
      },
      {
        "x": 2005,
        "y": 511
      },
      {
        "x": 2006,
        "y": 547
      },
      {
        "x": 2007,
        "y": 598
      },
      {
        "x": 2008,
        "y": 619
      },
      {
        "x": 2009,
        "y": 770
      },
      {
        "x": 2010,
        "y": 864
      },
      {
        "x": 2011,
        "y": 1060
      },
      {
        "x": 2012,
        "y": 1311
      },
      {
        "x": 2013,
        "y": 1572
      },
      {
        "x": 2014,
        "y": 1587
      }
    ]
  },
  {
    "id": "tubocurarine",
    "data": [
      {
        "x": 2004,
        "y": 34
      },
      {
        "x": 2005,
        "y": 68
      },
      {
        "x": 2006,
        "y": 68
      },
      {
        "x": 2007,
        "y": 68
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 68
      },
      {
        "x": 2010,
        "y": 95
      },
      {
        "x": 2011,
        "y": 104
      },
      {
        "x": 2012,
        "y": 104
      },
      {
        "x": 2013,
        "y": 110
      },
      {
        "x": 2014,
        "y": 112
      }
    ]
  },
  {
    "id": "unoprostone",
    "data": [
      {
        "x": 2004,
        "y": 2
      },
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 28
      },
      {
        "x": 2011,
        "y": 29
      },
      {
        "x": 2012,
        "y": 32
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 34
      }
    ]
  },
  {
    "id": "veralipride",
    "data": [
      {
        "x": 2004,
        "y": 48
      },
      {
        "x": 2005,
        "y": 99
      },
      {
        "x": 2006,
        "y": 150
      },
      {
        "x": 2007,
        "y": 164
      },
      {
        "x": 2008,
        "y": 180
      },
      {
        "x": 2009,
        "y": 201
      },
      {
        "x": 2010,
        "y": 258
      },
      {
        "x": 2011,
        "y": 276
      },
      {
        "x": 2012,
        "y": 280
      },
      {
        "x": 2013,
        "y": 284
      },
      {
        "x": 2014,
        "y": 284
      }
    ]
  },
  {
    "id": "viloxazine",
    "data": [
      {
        "x": 2004,
        "y": 107
      },
      {
        "x": 2005,
        "y": 178
      },
      {
        "x": 2006,
        "y": 428
      },
      {
        "x": 2007,
        "y": 464
      },
      {
        "x": 2008,
        "y": 480
      },
      {
        "x": 2009,
        "y": 485
      },
      {
        "x": 2010,
        "y": 506
      },
      {
        "x": 2011,
        "y": 508
      },
      {
        "x": 2012,
        "y": 508
      },
      {
        "x": 2013,
        "y": 538
      },
      {
        "x": 2014,
        "y": 628
      }
    ]
  },
  {
    "id": "vinburnine",
    "data": [
      {
        "x": 2004,
        "y": 63
      },
      {
        "x": 2005,
        "y": 113
      },
      {
        "x": 2006,
        "y": 168
      },
      {
        "x": 2007,
        "y": 219
      },
      {
        "x": 2008,
        "y": 276
      },
      {
        "x": 2009,
        "y": 380
      },
      {
        "x": 2010,
        "y": 380
      },
      {
        "x": 2011,
        "y": 380
      },
      {
        "x": 2012,
        "y": 380
      },
      {
        "x": 2013,
        "y": 380
      },
      {
        "x": 2014,
        "y": 380
      }
    ]
  },
  {
    "id": "zinc orotate",
    "data": [
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 18
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 30
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 63
      },
      {
        "x": 2011,
        "y": 68
      },
      {
        "x": 2012,
        "y": 104
      },
      {
        "x": 2013,
        "y": 134
      },
      {
        "x": 2014,
        "y": 170
      }
    ]
  },
  {
    "id": "zinc picolinate",
    "data": [
      {
        "x": 2004,
        "y": 42
      },
      {
        "x": 2005,
        "y": 150
      },
      {
        "x": 2006,
        "y": 172
      },
      {
        "x": 2007,
        "y": 174
      },
      {
        "x": 2008,
        "y": 180
      },
      {
        "x": 2009,
        "y": 192
      },
      {
        "x": 2010,
        "y": 192
      },
      {
        "x": 2011,
        "y": 204
      },
      {
        "x": 2012,
        "y": 322
      },
      {
        "x": 2013,
        "y": 487
      },
      {
        "x": 2014,
        "y": 500
      }
    ]
  },
  {
    "id": "zipeprol",
    "data": [
      {
        "x": 2004,
        "y": 6
      },
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 17
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "zomepirac",
    "data": [
      {
        "x": 2004,
        "y": 12
      },
      {
        "x": 2005,
        "y": 149
      },
      {
        "x": 2006,
        "y": 310
      },
      {
        "x": 2007,
        "y": 312
      },
      {
        "x": 2008,
        "y": 339
      },
      {
        "x": 2009,
        "y": 383
      },
      {
        "x": 2010,
        "y": 390
      },
      {
        "x": 2011,
        "y": 393
      },
      {
        "x": 2012,
        "y": 443
      },
      {
        "x": 2013,
        "y": 457
      },
      {
        "x": 2014,
        "y": 548
      }
    ]
  },
  {
    "id": "acetophenazine",
    "data": [
      {
        "x": 2005,
        "y": 3
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 21
      }
    ]
  },
  {
    "id": "alminoprofen",
    "data": [
      {
        "x": 2005,
        "y": 32
      },
      {
        "x": 2006,
        "y": 64
      },
      {
        "x": 2007,
        "y": 64
      },
      {
        "x": 2008,
        "y": 64
      },
      {
        "x": 2009,
        "y": 103
      },
      {
        "x": 2010,
        "y": 116
      },
      {
        "x": 2011,
        "y": 116
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 116
      },
      {
        "x": 2014,
        "y": 116
      }
    ]
  },
  {
    "id": "alphaprodine",
    "data": [
      {
        "x": 2005,
        "y": 10
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "ambroxol-theophylline-7-acetate",
    "data": [
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 26
      },
      {
        "x": 2009,
        "y": 78
      },
      {
        "x": 2010,
        "y": 143
      },
      {
        "x": 2011,
        "y": 159
      },
      {
        "x": 2012,
        "y": 168
      },
      {
        "x": 2013,
        "y": 168
      },
      {
        "x": 2014,
        "y": 168
      }
    ]
  },
  {
    "id": "aminoquinuride",
    "data": [
      {
        "x": 2005,
        "y": 87
      },
      {
        "x": 2006,
        "y": 116
      },
      {
        "x": 2007,
        "y": 116
      },
      {
        "x": 2008,
        "y": 116
      },
      {
        "x": 2009,
        "y": 116
      },
      {
        "x": 2010,
        "y": 116
      },
      {
        "x": 2011,
        "y": 116
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 116
      },
      {
        "x": 2014,
        "y": 116
      }
    ]
  },
  {
    "id": "amodiaquine",
    "data": [
      {
        "x": 2005,
        "y": 3
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 62
      },
      {
        "x": 2009,
        "y": 193
      },
      {
        "x": 2010,
        "y": 207
      },
      {
        "x": 2011,
        "y": 208
      },
      {
        "x": 2012,
        "y": 208
      },
      {
        "x": 2013,
        "y": 226
      },
      {
        "x": 2014,
        "y": 263
      }
    ]
  },
  {
    "id": "amyl nitrite",
    "data": [
      {
        "x": 2005,
        "y": 18
      },
      {
        "x": 2006,
        "y": 42
      },
      {
        "x": 2007,
        "y": 53
      },
      {
        "x": 2008,
        "y": 62
      },
      {
        "x": 2009,
        "y": 72
      },
      {
        "x": 2010,
        "y": 86
      },
      {
        "x": 2011,
        "y": 103
      },
      {
        "x": 2012,
        "y": 137
      },
      {
        "x": 2013,
        "y": 140
      },
      {
        "x": 2014,
        "y": 148
      }
    ]
  },
  {
    "id": "anethole",
    "data": [
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 59
      },
      {
        "x": 2007,
        "y": 79
      },
      {
        "x": 2008,
        "y": 80
      },
      {
        "x": 2009,
        "y": 80
      },
      {
        "x": 2010,
        "y": 80
      },
      {
        "x": 2011,
        "y": 80
      },
      {
        "x": 2012,
        "y": 80
      },
      {
        "x": 2013,
        "y": 80
      },
      {
        "x": 2014,
        "y": 80
      }
    ]
  },
  {
    "id": "apazone",
    "data": [
      {
        "x": 2005,
        "y": 24
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 26
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "arginine glutamate",
    "data": [
      {
        "x": 2005,
        "y": 76
      },
      {
        "x": 2006,
        "y": 82
      },
      {
        "x": 2007,
        "y": 100
      },
      {
        "x": 2008,
        "y": 108
      },
      {
        "x": 2009,
        "y": 108
      },
      {
        "x": 2010,
        "y": 108
      },
      {
        "x": 2011,
        "y": 108
      },
      {
        "x": 2012,
        "y": 109
      },
      {
        "x": 2013,
        "y": 112
      },
      {
        "x": 2014,
        "y": 112
      }
    ]
  },
  {
    "id": "azintamide",
    "data": [
      {
        "x": 2005,
        "y": 9
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 30
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 56
      },
      {
        "x": 2014,
        "y": 56
      }
    ]
  },
  {
    "id": "benzoxonium",
    "data": [
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "bismuth subnitrate",
    "data": [
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 10
      },
      {
        "x": 2008,
        "y": 30
      },
      {
        "x": 2009,
        "y": 56
      },
      {
        "x": 2010,
        "y": 63
      },
      {
        "x": 2011,
        "y": 64
      },
      {
        "x": 2012,
        "y": 64
      },
      {
        "x": 2013,
        "y": 188
      },
      {
        "x": 2014,
        "y": 192
      }
    ]
  },
  {
    "id": "camphor, (-)-",
    "data": [
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 36
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 36
      },
      {
        "x": 2009,
        "y": 103
      },
      {
        "x": 2010,
        "y": 232
      },
      {
        "x": 2011,
        "y": 342
      },
      {
        "x": 2012,
        "y": 348
      },
      {
        "x": 2013,
        "y": 364
      },
      {
        "x": 2014,
        "y": 364
      }
    ]
  },
  {
    "id": "ceforanide",
    "data": [
      {
        "x": 2005,
        "y": 6
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "chloral betaine",
    "data": [
      {
        "x": 2005,
        "y": 1
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "chlorcyclizine",
    "data": [
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 96
      },
      {
        "x": 2007,
        "y": 99
      },
      {
        "x": 2008,
        "y": 100
      },
      {
        "x": 2009,
        "y": 100
      },
      {
        "x": 2010,
        "y": 100
      },
      {
        "x": 2011,
        "y": 108
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 117
      },
      {
        "x": 2014,
        "y": 120
      }
    ]
  },
  {
    "id": "chlorine",
    "data": [
      {
        "x": 2005,
        "y": 10
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 41
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 100
      },
      {
        "x": 2011,
        "y": 100
      },
      {
        "x": 2012,
        "y": 101
      },
      {
        "x": 2013,
        "y": 120
      },
      {
        "x": 2014,
        "y": 130
      }
    ]
  },
  {
    "id": "chlorproethazine",
    "data": [
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "copper gluconate",
    "data": [
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 10
      },
      {
        "x": 2010,
        "y": 72
      },
      {
        "x": 2011,
        "y": 104
      },
      {
        "x": 2012,
        "y": 106
      },
      {
        "x": 2013,
        "y": 112
      },
      {
        "x": 2014,
        "y": 118
      }
    ]
  },
  {
    "id": "cyclofenil",
    "data": [
      {
        "x": 2005,
        "y": 3
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 32
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "dehydrocholate",
    "data": [
      {
        "x": 2005,
        "y": 9
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 25
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "deslorelin",
    "data": [
      {
        "x": 2005,
        "y": 6
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "dexetimide",
    "data": [
      {
        "x": 2005,
        "y": 173
      },
      {
        "x": 2006,
        "y": 188
      },
      {
        "x": 2007,
        "y": 188
      },
      {
        "x": 2008,
        "y": 188
      },
      {
        "x": 2009,
        "y": 191
      },
      {
        "x": 2010,
        "y": 368
      },
      {
        "x": 2011,
        "y": 372
      },
      {
        "x": 2012,
        "y": 376
      },
      {
        "x": 2013,
        "y": 376
      },
      {
        "x": 2014,
        "y": 376
      }
    ]
  },
  {
    "id": "dextromoramide",
    "data": [
      {
        "x": 2005,
        "y": 35
      },
      {
        "x": 2006,
        "y": 52
      },
      {
        "x": 2007,
        "y": 78
      },
      {
        "x": 2008,
        "y": 85
      },
      {
        "x": 2009,
        "y": 92
      },
      {
        "x": 2010,
        "y": 122
      },
      {
        "x": 2011,
        "y": 209
      },
      {
        "x": 2012,
        "y": 284
      },
      {
        "x": 2013,
        "y": 284
      },
      {
        "x": 2014,
        "y": 284
      }
    ]
  },
  {
    "id": "diatrizoic acid",
    "data": [
      {
        "x": 2005,
        "y": 15
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 42
      },
      {
        "x": 2011,
        "y": 108
      },
      {
        "x": 2012,
        "y": 108
      },
      {
        "x": 2013,
        "y": 123
      },
      {
        "x": 2014,
        "y": 128
      }
    ]
  },
  {
    "id": "dibrompropamidine",
    "data": [
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 18
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "emepronium",
    "data": [
      {
        "x": 2005,
        "y": 36
      },
      {
        "x": 2006,
        "y": 36
      },
      {
        "x": 2007,
        "y": 39
      },
      {
        "x": 2008,
        "y": 48
      },
      {
        "x": 2009,
        "y": 65
      },
      {
        "x": 2010,
        "y": 80
      },
      {
        "x": 2011,
        "y": 80
      },
      {
        "x": 2012,
        "y": 89
      },
      {
        "x": 2013,
        "y": 152
      },
      {
        "x": 2014,
        "y": 164
      }
    ]
  },
  {
    "id": "ethotoin",
    "data": [
      {
        "x": 2005,
        "y": 3
      },
      {
        "x": 2006,
        "y": 44
      },
      {
        "x": 2007,
        "y": 48
      },
      {
        "x": 2008,
        "y": 54
      },
      {
        "x": 2009,
        "y": 71
      },
      {
        "x": 2010,
        "y": 114
      },
      {
        "x": 2011,
        "y": 153
      },
      {
        "x": 2012,
        "y": 348
      },
      {
        "x": 2013,
        "y": 371
      },
      {
        "x": 2014,
        "y": 404
      }
    ]
  },
  {
    "id": "etofibrate",
    "data": [
      {
        "x": 2005,
        "y": 18
      },
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 34
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "fenbufen",
    "data": [
      {
        "x": 2005,
        "y": 16
      },
      {
        "x": 2006,
        "y": 56
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 68
      },
      {
        "x": 2010,
        "y": 80
      },
      {
        "x": 2011,
        "y": 80
      },
      {
        "x": 2012,
        "y": 80
      },
      {
        "x": 2013,
        "y": 80
      },
      {
        "x": 2014,
        "y": 80
      }
    ]
  },
  {
    "id": "fendiline",
    "data": [
      {
        "x": 2005,
        "y": 11
      },
      {
        "x": 2006,
        "y": 44
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "ferric oxide",
    "data": [
      {
        "x": 2005,
        "y": 9
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 33
      },
      {
        "x": 2013,
        "y": 72
      },
      {
        "x": 2014,
        "y": 73
      }
    ]
  },
  {
    "id": "ferric sulfate",
    "data": [
      {
        "x": 2005,
        "y": 3
      },
      {
        "x": 2006,
        "y": 159
      },
      {
        "x": 2007,
        "y": 180
      },
      {
        "x": 2008,
        "y": 190
      },
      {
        "x": 2009,
        "y": 202
      },
      {
        "x": 2010,
        "y": 214
      },
      {
        "x": 2011,
        "y": 224
      },
      {
        "x": 2012,
        "y": 224
      },
      {
        "x": 2013,
        "y": 246
      },
      {
        "x": 2014,
        "y": 252
      }
    ]
  },
  {
    "id": "ferrous chloride",
    "data": [
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 25
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 28
      },
      {
        "x": 2011,
        "y": 28
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 53
      }
    ]
  },
  {
    "id": "flumequine",
    "data": [
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "gallium nitrate",
    "data": [
      {
        "x": 2005,
        "y": 73
      },
      {
        "x": 2006,
        "y": 236
      },
      {
        "x": 2007,
        "y": 280
      },
      {
        "x": 2008,
        "y": 280
      },
      {
        "x": 2009,
        "y": 280
      },
      {
        "x": 2010,
        "y": 280
      },
      {
        "x": 2011,
        "y": 280
      },
      {
        "x": 2012,
        "y": 316
      },
      {
        "x": 2013,
        "y": 360
      },
      {
        "x": 2014,
        "y": 360
      }
    ]
  },
  {
    "id": "glibornuride",
    "data": [
      {
        "x": 2005,
        "y": 70
      },
      {
        "x": 2006,
        "y": 116
      },
      {
        "x": 2007,
        "y": 116
      },
      {
        "x": 2008,
        "y": 120
      },
      {
        "x": 2009,
        "y": 140
      },
      {
        "x": 2010,
        "y": 148
      },
      {
        "x": 2011,
        "y": 156
      },
      {
        "x": 2012,
        "y": 156
      },
      {
        "x": 2013,
        "y": 159
      },
      {
        "x": 2014,
        "y": 160
      }
    ]
  },
  {
    "id": "glutethimide",
    "data": [
      {
        "x": 2005,
        "y": 10
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 28
      },
      {
        "x": 2011,
        "y": 28
      },
      {
        "x": 2012,
        "y": 28
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 33
      }
    ]
  },
  {
    "id": "helium",
    "data": [
      {
        "x": 2005,
        "y": 3
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 5
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 18
      },
      {
        "x": 2014,
        "y": 97
      }
    ]
  },
  {
    "id": "histidine",
    "data": [
      {
        "x": 2005,
        "y": 7
      },
      {
        "x": 2006,
        "y": 28
      },
      {
        "x": 2007,
        "y": 28
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 46
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 48
      },
      {
        "x": 2014,
        "y": 48
      }
    ]
  },
  {
    "id": "idrocilamide",
    "data": [
      {
        "x": 2005,
        "y": 2
      },
      {
        "x": 2006,
        "y": 68
      },
      {
        "x": 2007,
        "y": 68
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 68
      },
      {
        "x": 2010,
        "y": 76
      },
      {
        "x": 2011,
        "y": 76
      },
      {
        "x": 2012,
        "y": 78
      },
      {
        "x": 2013,
        "y": 84
      },
      {
        "x": 2014,
        "y": 84
      }
    ]
  },
  {
    "id": "iprazochrome",
    "data": [
      {
        "x": 2005,
        "y": 116
      },
      {
        "x": 2006,
        "y": 116
      },
      {
        "x": 2007,
        "y": 116
      },
      {
        "x": 2008,
        "y": 116
      },
      {
        "x": 2009,
        "y": 116
      },
      {
        "x": 2010,
        "y": 116
      },
      {
        "x": 2011,
        "y": 116
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 116
      },
      {
        "x": 2014,
        "y": 116
      }
    ]
  },
  {
    "id": "iproniazid",
    "data": [
      {
        "x": 2005,
        "y": 18
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 48
      },
      {
        "x": 2011,
        "y": 64
      },
      {
        "x": 2012,
        "y": 77
      },
      {
        "x": 2013,
        "y": 80
      },
      {
        "x": 2014,
        "y": 179
      }
    ]
  },
  {
    "id": "isoconazole",
    "data": [
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 30
      },
      {
        "x": 2008,
        "y": 52
      },
      {
        "x": 2009,
        "y": 75
      },
      {
        "x": 2010,
        "y": 193
      },
      {
        "x": 2011,
        "y": 221
      },
      {
        "x": 2012,
        "y": 233
      },
      {
        "x": 2013,
        "y": 236
      },
      {
        "x": 2014,
        "y": 267
      }
    ]
  },
  {
    "id": "ketazolam",
    "data": [
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 60
      },
      {
        "x": 2007,
        "y": 60
      },
      {
        "x": 2008,
        "y": 117
      },
      {
        "x": 2009,
        "y": 157
      },
      {
        "x": 2010,
        "y": 178
      },
      {
        "x": 2011,
        "y": 214
      },
      {
        "x": 2012,
        "y": 224
      },
      {
        "x": 2013,
        "y": 259
      },
      {
        "x": 2014,
        "y": 282
      }
    ]
  },
  {
    "id": "mecamylamine",
    "data": [
      {
        "x": 2005,
        "y": 8
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 54
      }
    ]
  },
  {
    "id": "medrysone",
    "data": [
      {
        "x": 2005,
        "y": 48
      },
      {
        "x": 2006,
        "y": 48
      },
      {
        "x": 2007,
        "y": 48
      },
      {
        "x": 2008,
        "y": 48
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 48
      },
      {
        "x": 2011,
        "y": 48
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 92
      },
      {
        "x": 2014,
        "y": 136
      }
    ]
  },
  {
    "id": "mequinol",
    "data": [
      {
        "x": 2005,
        "y": 13
      },
      {
        "x": 2006,
        "y": 28
      },
      {
        "x": 2007,
        "y": 34
      },
      {
        "x": 2008,
        "y": 104
      },
      {
        "x": 2009,
        "y": 123
      },
      {
        "x": 2010,
        "y": 208
      },
      {
        "x": 2011,
        "y": 208
      },
      {
        "x": 2012,
        "y": 208
      },
      {
        "x": 2013,
        "y": 208
      },
      {
        "x": 2014,
        "y": 208
      }
    ]
  },
  {
    "id": "methdilazine",
    "data": [
      {
        "x": 2005,
        "y": 34
      },
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 52
      },
      {
        "x": 2008,
        "y": 52
      },
      {
        "x": 2009,
        "y": 52
      },
      {
        "x": 2010,
        "y": 52
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 64
      }
    ]
  },
  {
    "id": "monensin",
    "data": [
      {
        "x": 2005,
        "y": 2
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "monobenzone",
    "data": [
      {
        "x": 2005,
        "y": 69
      },
      {
        "x": 2006,
        "y": 92
      },
      {
        "x": 2007,
        "y": 92
      },
      {
        "x": 2008,
        "y": 92
      },
      {
        "x": 2009,
        "y": 92
      },
      {
        "x": 2010,
        "y": 92
      },
      {
        "x": 2011,
        "y": 92
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 92
      },
      {
        "x": 2014,
        "y": 92
      }
    ]
  },
  {
    "id": "moxidectin",
    "data": [
      {
        "x": 2005,
        "y": 15
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "niaprazine",
    "data": [
      {
        "x": 2005,
        "y": 29
      },
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 40
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 41
      },
      {
        "x": 2010,
        "y": 50
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 77
      },
      {
        "x": 2013,
        "y": 111
      },
      {
        "x": 2014,
        "y": 127
      }
    ]
  },
  {
    "id": "nikethamide",
    "data": [
      {
        "x": 2005,
        "y": 28
      },
      {
        "x": 2006,
        "y": 44
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 87
      },
      {
        "x": 2010,
        "y": 96
      },
      {
        "x": 2011,
        "y": 99
      },
      {
        "x": 2012,
        "y": 102
      },
      {
        "x": 2013,
        "y": 108
      },
      {
        "x": 2014,
        "y": 128
      }
    ]
  },
  {
    "id": "nimorazole",
    "data": [
      {
        "x": 2005,
        "y": 22
      },
      {
        "x": 2006,
        "y": 49
      },
      {
        "x": 2007,
        "y": 64
      },
      {
        "x": 2008,
        "y": 64
      },
      {
        "x": 2009,
        "y": 64
      },
      {
        "x": 2010,
        "y": 64
      },
      {
        "x": 2011,
        "y": 64
      },
      {
        "x": 2012,
        "y": 64
      },
      {
        "x": 2013,
        "y": 64
      },
      {
        "x": 2014,
        "y": 64
      }
    ]
  },
  {
    "id": "nitroxoline",
    "data": [
      {
        "x": 2005,
        "y": 47
      },
      {
        "x": 2006,
        "y": 124
      },
      {
        "x": 2007,
        "y": 127
      },
      {
        "x": 2008,
        "y": 136
      },
      {
        "x": 2009,
        "y": 136
      },
      {
        "x": 2010,
        "y": 140
      },
      {
        "x": 2011,
        "y": 148
      },
      {
        "x": 2012,
        "y": 148
      },
      {
        "x": 2013,
        "y": 148
      },
      {
        "x": 2014,
        "y": 191
      }
    ]
  },
  {
    "id": "oxamniquine",
    "data": [
      {
        "x": 2005,
        "y": 5
      },
      {
        "x": 2006,
        "y": 48
      },
      {
        "x": 2007,
        "y": 48
      },
      {
        "x": 2008,
        "y": 48
      },
      {
        "x": 2009,
        "y": 66
      },
      {
        "x": 2010,
        "y": 72
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 76
      },
      {
        "x": 2013,
        "y": 82
      },
      {
        "x": 2014,
        "y": 84
      }
    ]
  },
  {
    "id": "oxilofrine",
    "data": [
      {
        "x": 2005,
        "y": 36
      },
      {
        "x": 2006,
        "y": 62
      },
      {
        "x": 2007,
        "y": 76
      },
      {
        "x": 2008,
        "y": 76
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 76
      },
      {
        "x": 2011,
        "y": 76
      },
      {
        "x": 2012,
        "y": 76
      },
      {
        "x": 2013,
        "y": 76
      },
      {
        "x": 2014,
        "y": 76
      }
    ]
  },
  {
    "id": "paramethadione",
    "data": [
      {
        "x": 2005,
        "y": 10
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "proglumetacin",
    "data": [
      {
        "x": 2005,
        "y": 26
      },
      {
        "x": 2006,
        "y": 78
      },
      {
        "x": 2007,
        "y": 88
      },
      {
        "x": 2008,
        "y": 91
      },
      {
        "x": 2009,
        "y": 133
      },
      {
        "x": 2010,
        "y": 147
      },
      {
        "x": 2011,
        "y": 148
      },
      {
        "x": 2012,
        "y": 148
      },
      {
        "x": 2013,
        "y": 148
      },
      {
        "x": 2014,
        "y": 148
      }
    ]
  },
  {
    "id": "saccharin",
    "data": [
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 49
      },
      {
        "x": 2012,
        "y": 76
      },
      {
        "x": 2013,
        "y": 84
      },
      {
        "x": 2014,
        "y": 509
      }
    ]
  },
  {
    "id": "secnidazole",
    "data": [
      {
        "x": 2005,
        "y": 9
      },
      {
        "x": 2006,
        "y": 18
      },
      {
        "x": 2007,
        "y": 27
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 50
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 154
      },
      {
        "x": 2013,
        "y": 183
      },
      {
        "x": 2014,
        "y": 228
      }
    ]
  },
  {
    "id": "sisomicin",
    "data": [
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 40
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 120
      },
      {
        "x": 2011,
        "y": 141
      },
      {
        "x": 2012,
        "y": 148
      },
      {
        "x": 2013,
        "y": 148
      },
      {
        "x": 2014,
        "y": 148
      }
    ]
  },
  {
    "id": "sodium lauryl sulfoacetate",
    "data": [
      {
        "x": 2005,
        "y": 38
      },
      {
        "x": 2006,
        "y": 76
      },
      {
        "x": 2007,
        "y": 76
      },
      {
        "x": 2008,
        "y": 76
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 76
      },
      {
        "x": 2011,
        "y": 76
      },
      {
        "x": 2012,
        "y": 76
      },
      {
        "x": 2013,
        "y": 76
      },
      {
        "x": 2014,
        "y": 76
      }
    ]
  },
  {
    "id": "sulfadimethoxine",
    "data": [
      {
        "x": 2005,
        "y": 2
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 15
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "sulfaguanidine",
    "data": [
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "sulfamethoxypyridazine",
    "data": [
      {
        "x": 2005,
        "y": 72
      },
      {
        "x": 2006,
        "y": 72
      },
      {
        "x": 2007,
        "y": 80
      },
      {
        "x": 2008,
        "y": 80
      },
      {
        "x": 2009,
        "y": 80
      },
      {
        "x": 2010,
        "y": 84
      },
      {
        "x": 2011,
        "y": 96
      },
      {
        "x": 2012,
        "y": 135
      },
      {
        "x": 2013,
        "y": 148
      },
      {
        "x": 2014,
        "y": 152
      }
    ]
  },
  {
    "id": "talniflumate",
    "data": [
      {
        "x": 2005,
        "y": 9
      },
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 38
      },
      {
        "x": 2010,
        "y": 75
      },
      {
        "x": 2011,
        "y": 88
      },
      {
        "x": 2012,
        "y": 99
      },
      {
        "x": 2013,
        "y": 122
      },
      {
        "x": 2014,
        "y": 134
      }
    ]
  },
  {
    "id": "tertatolol",
    "data": [
      {
        "x": 2005,
        "y": 20
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "theodrenaline",
    "data": [
      {
        "x": 2005,
        "y": 46
      },
      {
        "x": 2006,
        "y": 96
      },
      {
        "x": 2007,
        "y": 104
      },
      {
        "x": 2008,
        "y": 104
      },
      {
        "x": 2009,
        "y": 120
      },
      {
        "x": 2010,
        "y": 120
      },
      {
        "x": 2011,
        "y": 120
      },
      {
        "x": 2012,
        "y": 120
      },
      {
        "x": 2013,
        "y": 120
      },
      {
        "x": 2014,
        "y": 120
      }
    ]
  },
  {
    "id": "thiamphenicol",
    "data": [
      {
        "x": 2005,
        "y": 43
      },
      {
        "x": 2006,
        "y": 82
      },
      {
        "x": 2007,
        "y": 84
      },
      {
        "x": 2008,
        "y": 84
      },
      {
        "x": 2009,
        "y": 96
      },
      {
        "x": 2010,
        "y": 183
      },
      {
        "x": 2011,
        "y": 240
      },
      {
        "x": 2012,
        "y": 240
      },
      {
        "x": 2013,
        "y": 252
      },
      {
        "x": 2014,
        "y": 300
      }
    ]
  },
  {
    "id": "tocainide",
    "data": [
      {
        "x": 2005,
        "y": 14
      },
      {
        "x": 2006,
        "y": 28
      },
      {
        "x": 2007,
        "y": 28
      },
      {
        "x": 2008,
        "y": 46
      },
      {
        "x": 2009,
        "y": 64
      },
      {
        "x": 2010,
        "y": 82
      },
      {
        "x": 2011,
        "y": 132
      },
      {
        "x": 2012,
        "y": 164
      },
      {
        "x": 2013,
        "y": 166
      },
      {
        "x": 2014,
        "y": 200
      }
    ]
  },
  {
    "id": "tolfenamic acid",
    "data": [
      {
        "x": 2005,
        "y": 33
      },
      {
        "x": 2006,
        "y": 55
      },
      {
        "x": 2007,
        "y": 62
      },
      {
        "x": 2008,
        "y": 155
      },
      {
        "x": 2009,
        "y": 196
      },
      {
        "x": 2010,
        "y": 210
      },
      {
        "x": 2011,
        "y": 224
      },
      {
        "x": 2012,
        "y": 303
      },
      {
        "x": 2013,
        "y": 325
      },
      {
        "x": 2014,
        "y": 346
      }
    ]
  },
  {
    "id": "toluene",
    "data": [
      {
        "x": 2005,
        "y": 10
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 23
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 28
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "trimetrexate",
    "data": [
      {
        "x": 2005,
        "y": 52
      },
      {
        "x": 2006,
        "y": 104
      },
      {
        "x": 2007,
        "y": 104
      },
      {
        "x": 2008,
        "y": 104
      },
      {
        "x": 2009,
        "y": 104
      },
      {
        "x": 2010,
        "y": 116
      },
      {
        "x": 2011,
        "y": 132
      },
      {
        "x": 2012,
        "y": 132
      },
      {
        "x": 2013,
        "y": 132
      },
      {
        "x": 2014,
        "y": 148
      }
    ]
  },
  {
    "id": "undecylenate",
    "data": [
      {
        "x": 2005,
        "y": 10
      },
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 34
      },
      {
        "x": 2008,
        "y": 48
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 54
      },
      {
        "x": 2011,
        "y": 60
      },
      {
        "x": 2012,
        "y": 66
      },
      {
        "x": 2013,
        "y": 76
      },
      {
        "x": 2014,
        "y": 158
      }
    ]
  },
  {
    "id": "uridine",
    "data": [
      {
        "x": 2005,
        "y": 40
      },
      {
        "x": 2006,
        "y": 137
      },
      {
        "x": 2007,
        "y": 140
      },
      {
        "x": 2008,
        "y": 140
      },
      {
        "x": 2009,
        "y": 142
      },
      {
        "x": 2010,
        "y": 144
      },
      {
        "x": 2011,
        "y": 144
      },
      {
        "x": 2012,
        "y": 144
      },
      {
        "x": 2013,
        "y": 156
      },
      {
        "x": 2014,
        "y": 156
      }
    ]
  },
  {
    "id": "vanadium",
    "data": [
      {
        "x": 2005,
        "y": 4
      },
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 18
      }
    ]
  },
  {
    "id": "virginiamycin",
    "data": [
      {
        "x": 2005,
        "y": 12
      },
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "xylazine",
    "data": [
      {
        "x": 2005,
        "y": 92
      },
      {
        "x": 2006,
        "y": 92
      },
      {
        "x": 2007,
        "y": 92
      },
      {
        "x": 2008,
        "y": 140
      },
      {
        "x": 2009,
        "y": 183
      },
      {
        "x": 2010,
        "y": 192
      },
      {
        "x": 2011,
        "y": 192
      },
      {
        "x": 2012,
        "y": 192
      },
      {
        "x": 2013,
        "y": 210
      },
      {
        "x": 2014,
        "y": 216
      }
    ]
  },
  {
    "id": "amlexanox",
    "data": [
      {
        "x": 2006,
        "y": 27
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 64
      },
      {
        "x": 2009,
        "y": 81
      },
      {
        "x": 2010,
        "y": 108
      },
      {
        "x": 2011,
        "y": 136
      },
      {
        "x": 2012,
        "y": 188
      },
      {
        "x": 2013,
        "y": 188
      },
      {
        "x": 2014,
        "y": 288
      }
    ]
  },
  {
    "id": "asiaticoside",
    "data": [
      {
        "x": 2006,
        "y": 5
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "bamipine",
    "data": [
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "cafedrine",
    "data": [
      {
        "x": 2006,
        "y": 2
      },
      {
        "x": 2007,
        "y": 23
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 77
      },
      {
        "x": 2012,
        "y": 88
      },
      {
        "x": 2013,
        "y": 88
      },
      {
        "x": 2014,
        "y": 88
      }
    ]
  },
  {
    "id": "calcium sulfate",
    "data": [
      {
        "x": 2006,
        "y": 9
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 36
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 80
      },
      {
        "x": 2014,
        "y": 80
      }
    ]
  },
  {
    "id": "carbaryl",
    "data": [
      {
        "x": 2006,
        "y": 5
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 34
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 48
      },
      {
        "x": 2011,
        "y": 48
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 48
      },
      {
        "x": 2014,
        "y": 48
      }
    ]
  },
  {
    "id": "chlorobutanol",
    "data": [
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 40
      },
      {
        "x": 2008,
        "y": 64
      },
      {
        "x": 2009,
        "y": 64
      },
      {
        "x": 2010,
        "y": 64
      },
      {
        "x": 2011,
        "y": 64
      },
      {
        "x": 2012,
        "y": 64
      },
      {
        "x": 2013,
        "y": 64
      },
      {
        "x": 2014,
        "y": 68
      }
    ]
  },
  {
    "id": "chromic chloride",
    "data": [
      {
        "x": 2006,
        "y": 42
      },
      {
        "x": 2007,
        "y": 56
      },
      {
        "x": 2008,
        "y": 77
      },
      {
        "x": 2009,
        "y": 140
      },
      {
        "x": 2010,
        "y": 140
      },
      {
        "x": 2011,
        "y": 140
      },
      {
        "x": 2012,
        "y": 140
      },
      {
        "x": 2013,
        "y": 140
      },
      {
        "x": 2014,
        "y": 140
      }
    ]
  },
  {
    "id": "clorsulon",
    "data": [
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 34
      },
      {
        "x": 2008,
        "y": 48
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 66
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 72
      },
      {
        "x": 2013,
        "y": 72
      },
      {
        "x": 2014,
        "y": 72
      }
    ]
  },
  {
    "id": "dehydroemetine",
    "data": [
      {
        "x": 2006,
        "y": 66
      },
      {
        "x": 2007,
        "y": 87
      },
      {
        "x": 2008,
        "y": 92
      },
      {
        "x": 2009,
        "y": 92
      },
      {
        "x": 2010,
        "y": 92
      },
      {
        "x": 2011,
        "y": 92
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 92
      },
      {
        "x": 2014,
        "y": 92
      }
    ]
  },
  {
    "id": "dihydroxyacetone",
    "data": [
      {
        "x": 2006,
        "y": 2
      },
      {
        "x": 2007,
        "y": 14
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 89
      },
      {
        "x": 2014,
        "y": 166
      }
    ]
  },
  {
    "id": "dihydroxyaluminum aminoacetate",
    "data": [
      {
        "x": 2006,
        "y": 20
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 30
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "diphenylpyraline",
    "data": [
      {
        "x": 2006,
        "y": 2
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 66
      },
      {
        "x": 2010,
        "y": 91
      },
      {
        "x": 2011,
        "y": 103
      },
      {
        "x": 2012,
        "y": 124
      },
      {
        "x": 2013,
        "y": 124
      },
      {
        "x": 2014,
        "y": 124
      }
    ]
  },
  {
    "id": "ethenzamide",
    "data": [
      {
        "x": 2006,
        "y": 16
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 80
      },
      {
        "x": 2011,
        "y": 100
      },
      {
        "x": 2012,
        "y": 121
      },
      {
        "x": 2013,
        "y": 126
      },
      {
        "x": 2014,
        "y": 155
      }
    ]
  },
  {
    "id": "etidocaine",
    "data": [
      {
        "x": 2006,
        "y": 33
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "flufenamic acid",
    "data": [
      {
        "x": 2006,
        "y": 5
      },
      {
        "x": 2007,
        "y": 28
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 67
      },
      {
        "x": 2010,
        "y": 106
      },
      {
        "x": 2011,
        "y": 142
      },
      {
        "x": 2012,
        "y": 170
      },
      {
        "x": 2013,
        "y": 239
      },
      {
        "x": 2014,
        "y": 286
      }
    ]
  },
  {
    "id": "fluprednidene",
    "data": [
      {
        "x": 2006,
        "y": 40
      },
      {
        "x": 2007,
        "y": 40
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 40
      },
      {
        "x": 2011,
        "y": 47
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 49
      },
      {
        "x": 2014,
        "y": 54
      }
    ]
  },
  {
    "id": "formestane",
    "data": [
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 14
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 25
      },
      {
        "x": 2010,
        "y": 28
      },
      {
        "x": 2011,
        "y": 28
      },
      {
        "x": 2012,
        "y": 28
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "gallium 67 citrate",
    "data": [
      {
        "x": 2006,
        "y": 2
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 60
      },
      {
        "x": 2009,
        "y": 64
      },
      {
        "x": 2010,
        "y": 72
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 72
      },
      {
        "x": 2013,
        "y": 81
      },
      {
        "x": 2014,
        "y": 93
      }
    ]
  },
  {
    "id": "glycol salicylate",
    "data": [
      {
        "x": 2006,
        "y": 2
      },
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 27
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 80
      },
      {
        "x": 2013,
        "y": 152
      },
      {
        "x": 2014,
        "y": 152
      }
    ]
  },
  {
    "id": "guaiazulene",
    "data": [
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 94
      },
      {
        "x": 2012,
        "y": 170
      },
      {
        "x": 2013,
        "y": 220
      },
      {
        "x": 2014,
        "y": 226
      }
    ]
  },
  {
    "id": "guanine",
    "data": [
      {
        "x": 2006,
        "y": 132
      },
      {
        "x": 2007,
        "y": 132
      },
      {
        "x": 2008,
        "y": 132
      },
      {
        "x": 2009,
        "y": 132
      },
      {
        "x": 2010,
        "y": 132
      },
      {
        "x": 2011,
        "y": 132
      },
      {
        "x": 2012,
        "y": 132
      },
      {
        "x": 2013,
        "y": 132
      },
      {
        "x": 2014,
        "y": 132
      }
    ]
  },
  {
    "id": "halofantrine",
    "data": [
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 112
      },
      {
        "x": 2008,
        "y": 272
      },
      {
        "x": 2009,
        "y": 432
      },
      {
        "x": 2010,
        "y": 432
      },
      {
        "x": 2011,
        "y": 432
      },
      {
        "x": 2012,
        "y": 432
      },
      {
        "x": 2013,
        "y": 432
      },
      {
        "x": 2014,
        "y": 432
      }
    ]
  },
  {
    "id": "indium-111",
    "data": [
      {
        "x": 2006,
        "y": 44
      },
      {
        "x": 2007,
        "y": 44
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "ketanserin",
    "data": [
      {
        "x": 2006,
        "y": 56
      },
      {
        "x": 2007,
        "y": 59
      },
      {
        "x": 2008,
        "y": 68
      },
      {
        "x": 2009,
        "y": 68
      },
      {
        "x": 2010,
        "y": 68
      },
      {
        "x": 2011,
        "y": 68
      },
      {
        "x": 2012,
        "y": 68
      },
      {
        "x": 2013,
        "y": 71
      },
      {
        "x": 2014,
        "y": 98
      }
    ]
  },
  {
    "id": "lanatoside c",
    "data": [
      {
        "x": 2006,
        "y": 48
      },
      {
        "x": 2007,
        "y": 57
      },
      {
        "x": 2008,
        "y": 83
      },
      {
        "x": 2009,
        "y": 100
      },
      {
        "x": 2010,
        "y": 115
      },
      {
        "x": 2011,
        "y": 175
      },
      {
        "x": 2012,
        "y": 180
      },
      {
        "x": 2013,
        "y": 180
      },
      {
        "x": 2014,
        "y": 180
      }
    ]
  },
  {
    "id": "levomethadyl",
    "data": [
      {
        "x": 2006,
        "y": 18
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "mandelic acid",
    "data": [
      {
        "x": 2006,
        "y": 4
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "manganese gluconate",
    "data": [
      {
        "x": 2006,
        "y": 2
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 40
      },
      {
        "x": 2011,
        "y": 40
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "merbromin",
    "data": [
      {
        "x": 2006,
        "y": 13
      },
      {
        "x": 2007,
        "y": 70
      },
      {
        "x": 2008,
        "y": 76
      },
      {
        "x": 2009,
        "y": 77
      },
      {
        "x": 2010,
        "y": 80
      },
      {
        "x": 2011,
        "y": 80
      },
      {
        "x": 2012,
        "y": 80
      },
      {
        "x": 2013,
        "y": 80
      },
      {
        "x": 2014,
        "y": 80
      }
    ]
  },
  {
    "id": "moricizine",
    "data": [
      {
        "x": 2006,
        "y": 80
      },
      {
        "x": 2007,
        "y": 103
      },
      {
        "x": 2008,
        "y": 125
      },
      {
        "x": 2009,
        "y": 150
      },
      {
        "x": 2010,
        "y": 164
      },
      {
        "x": 2011,
        "y": 164
      },
      {
        "x": 2012,
        "y": 578
      },
      {
        "x": 2013,
        "y": 716
      },
      {
        "x": 2014,
        "y": 716
      }
    ]
  },
  {
    "id": "n,n-dimethylglycine",
    "data": [
      {
        "x": 2006,
        "y": 69
      },
      {
        "x": 2007,
        "y": 92
      },
      {
        "x": 2008,
        "y": 92
      },
      {
        "x": 2009,
        "y": 92
      },
      {
        "x": 2010,
        "y": 92
      },
      {
        "x": 2011,
        "y": 92
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 92
      },
      {
        "x": 2014,
        "y": 92
      }
    ]
  },
  {
    "id": "oleandomycin",
    "data": [
      {
        "x": 2006,
        "y": 6
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 25
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "oxaceprol",
    "data": [
      {
        "x": 2006,
        "y": 6
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "oxolamine",
    "data": [
      {
        "x": 2006,
        "y": 66
      },
      {
        "x": 2007,
        "y": 90
      },
      {
        "x": 2008,
        "y": 98
      },
      {
        "x": 2009,
        "y": 128
      },
      {
        "x": 2010,
        "y": 151
      },
      {
        "x": 2011,
        "y": 156
      },
      {
        "x": 2012,
        "y": 168
      },
      {
        "x": 2013,
        "y": 180
      },
      {
        "x": 2014,
        "y": 181
      }
    ]
  },
  {
    "id": "oxolinic acid",
    "data": [
      {
        "x": 2006,
        "y": 2
      },
      {
        "x": 2007,
        "y": 11
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "oxyfedrine",
    "data": [
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 32
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 32
      }
    ]
  },
  {
    "id": "phenacemide",
    "data": [
      {
        "x": 2006,
        "y": 148
      },
      {
        "x": 2007,
        "y": 148
      },
      {
        "x": 2008,
        "y": 148
      },
      {
        "x": 2009,
        "y": 148
      },
      {
        "x": 2010,
        "y": 148
      },
      {
        "x": 2011,
        "y": 148
      },
      {
        "x": 2012,
        "y": 232
      },
      {
        "x": 2013,
        "y": 232
      },
      {
        "x": 2014,
        "y": 232
      }
    ]
  },
  {
    "id": "potassium carbonate",
    "data": [
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 60
      },
      {
        "x": 2010,
        "y": 194
      },
      {
        "x": 2011,
        "y": 408
      },
      {
        "x": 2012,
        "y": 471
      },
      {
        "x": 2013,
        "y": 504
      },
      {
        "x": 2014,
        "y": 504
      }
    ]
  },
  {
    "id": "potassium hydroxide",
    "data": [
      {
        "x": 2006,
        "y": 12
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 21
      },
      {
        "x": 2010,
        "y": 48
      },
      {
        "x": 2011,
        "y": 60
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 70
      }
    ]
  },
  {
    "id": "practolol",
    "data": [
      {
        "x": 2006,
        "y": 18
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 37
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 40
      },
      {
        "x": 2011,
        "y": 66
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 92
      },
      {
        "x": 2014,
        "y": 92
      }
    ]
  },
  {
    "id": "prednylidene",
    "data": [
      {
        "x": 2006,
        "y": 30
      },
      {
        "x": 2007,
        "y": 40
      },
      {
        "x": 2008,
        "y": 43
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "proflavine",
    "data": [
      {
        "x": 2006,
        "y": 32
      },
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 32
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 35
      }
    ]
  },
  {
    "id": "proglumide",
    "data": [
      {
        "x": 2006,
        "y": 108
      },
      {
        "x": 2007,
        "y": 108
      },
      {
        "x": 2008,
        "y": 108
      },
      {
        "x": 2009,
        "y": 108
      },
      {
        "x": 2010,
        "y": 108
      },
      {
        "x": 2011,
        "y": 108
      },
      {
        "x": 2012,
        "y": 108
      },
      {
        "x": 2013,
        "y": 108
      },
      {
        "x": 2014,
        "y": 108
      }
    ]
  },
  {
    "id": "prolintane",
    "data": [
      {
        "x": 2006,
        "y": 1
      },
      {
        "x": 2007,
        "y": 16
      },
      {
        "x": 2008,
        "y": 52
      },
      {
        "x": 2009,
        "y": 52
      },
      {
        "x": 2010,
        "y": 52
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 52
      }
    ]
  },
  {
    "id": "propyphenazone",
    "data": [
      {
        "x": 2006,
        "y": 6
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 30
      },
      {
        "x": 2009,
        "y": 76
      },
      {
        "x": 2010,
        "y": 103
      },
      {
        "x": 2011,
        "y": 158
      },
      {
        "x": 2012,
        "y": 212
      },
      {
        "x": 2013,
        "y": 303
      },
      {
        "x": 2014,
        "y": 320
      }
    ]
  },
  {
    "id": "remoxipride",
    "data": [
      {
        "x": 2006,
        "y": 1
      },
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 14
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 48
      }
    ]
  },
  {
    "id": "selenomethionine se 75",
    "data": [
      {
        "x": 2006,
        "y": 8
      },
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "sodium hydroxide",
    "data": [
      {
        "x": 2006,
        "y": 36
      },
      {
        "x": 2007,
        "y": 36
      },
      {
        "x": 2008,
        "y": 78
      },
      {
        "x": 2009,
        "y": 232
      },
      {
        "x": 2010,
        "y": 252
      },
      {
        "x": 2011,
        "y": 252
      },
      {
        "x": 2012,
        "y": 252
      },
      {
        "x": 2013,
        "y": 316
      },
      {
        "x": 2014,
        "y": 335
      }
    ]
  },
  {
    "id": "spirapril",
    "data": [
      {
        "x": 2006,
        "y": 27
      },
      {
        "x": 2007,
        "y": 178
      },
      {
        "x": 2008,
        "y": 232
      },
      {
        "x": 2009,
        "y": 232
      },
      {
        "x": 2010,
        "y": 232
      },
      {
        "x": 2011,
        "y": 254
      },
      {
        "x": 2012,
        "y": 263
      },
      {
        "x": 2013,
        "y": 272
      },
      {
        "x": 2014,
        "y": 284
      }
    ]
  },
  {
    "id": "succimer",
    "data": [
      {
        "x": 2006,
        "y": 14
      },
      {
        "x": 2007,
        "y": 79
      },
      {
        "x": 2008,
        "y": 96
      },
      {
        "x": 2009,
        "y": 183
      },
      {
        "x": 2010,
        "y": 308
      },
      {
        "x": 2011,
        "y": 323
      },
      {
        "x": 2012,
        "y": 615
      },
      {
        "x": 2013,
        "y": 776
      },
      {
        "x": 2014,
        "y": 793
      }
    ]
  },
  {
    "id": "sulbenicillin",
    "data": [
      {
        "x": 2006,
        "y": 80
      },
      {
        "x": 2007,
        "y": 80
      },
      {
        "x": 2008,
        "y": 80
      },
      {
        "x": 2009,
        "y": 80
      },
      {
        "x": 2010,
        "y": 143
      },
      {
        "x": 2011,
        "y": 164
      },
      {
        "x": 2012,
        "y": 168
      },
      {
        "x": 2013,
        "y": 176
      },
      {
        "x": 2014,
        "y": 178
      }
    ]
  },
  {
    "id": "sulfinpyrazone",
    "data": [
      {
        "x": 2006,
        "y": 18
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 30
      },
      {
        "x": 2009,
        "y": 216
      },
      {
        "x": 2010,
        "y": 309
      },
      {
        "x": 2011,
        "y": 345
      },
      {
        "x": 2012,
        "y": 352
      },
      {
        "x": 2013,
        "y": 385
      },
      {
        "x": 2014,
        "y": 416
      }
    ]
  },
  {
    "id": "technetium tc 99m sulfur colloid",
    "data": [
      {
        "x": 2006,
        "y": 3
      },
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 39
      },
      {
        "x": 2010,
        "y": 80
      },
      {
        "x": 2011,
        "y": 80
      },
      {
        "x": 2012,
        "y": 80
      },
      {
        "x": 2013,
        "y": 80
      },
      {
        "x": 2014,
        "y": 92
      }
    ]
  },
  {
    "id": "temocillin",
    "data": [
      {
        "x": 2006,
        "y": 56
      },
      {
        "x": 2007,
        "y": 56
      },
      {
        "x": 2008,
        "y": 84
      },
      {
        "x": 2009,
        "y": 84
      },
      {
        "x": 2010,
        "y": 84
      },
      {
        "x": 2011,
        "y": 84
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 92
      },
      {
        "x": 2014,
        "y": 127
      }
    ]
  },
  {
    "id": "thimerosal",
    "data": [
      {
        "x": 2006,
        "y": 220
      },
      {
        "x": 2007,
        "y": 252
      },
      {
        "x": 2008,
        "y": 252
      },
      {
        "x": 2009,
        "y": 252
      },
      {
        "x": 2010,
        "y": 252
      },
      {
        "x": 2011,
        "y": 277
      },
      {
        "x": 2012,
        "y": 306
      },
      {
        "x": 2013,
        "y": 326
      },
      {
        "x": 2014,
        "y": 475
      }
    ]
  },
  {
    "id": "trimethylphloroglucinol",
    "data": [
      {
        "x": 2006,
        "y": 11
      },
      {
        "x": 2007,
        "y": 116
      },
      {
        "x": 2008,
        "y": 116
      },
      {
        "x": 2009,
        "y": 116
      },
      {
        "x": 2010,
        "y": 116
      },
      {
        "x": 2011,
        "y": 116
      },
      {
        "x": 2012,
        "y": 128
      },
      {
        "x": 2013,
        "y": 151
      },
      {
        "x": 2014,
        "y": 190
      }
    ]
  },
  {
    "id": "trofosfamide",
    "data": [
      {
        "x": 2006,
        "y": 24
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 27
      },
      {
        "x": 2011,
        "y": 42
      },
      {
        "x": 2012,
        "y": 54
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 68
      }
    ]
  },
  {
    "id": "tyramine",
    "data": [
      {
        "x": 2006,
        "y": 14
      },
      {
        "x": 2007,
        "y": 24
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 133
      },
      {
        "x": 2012,
        "y": 136
      },
      {
        "x": 2013,
        "y": 200
      },
      {
        "x": 2014,
        "y": 222
      }
    ]
  },
  {
    "id": "acetohydroxamic acid",
    "data": [
      {
        "x": 2007,
        "y": 13
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "antimony",
    "data": [
      {
        "x": 2007,
        "y": 20
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 49
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 52
      }
    ]
  },
  {
    "id": "benzophenone",
    "data": [
      {
        "x": 2007,
        "y": 15
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 28
      },
      {
        "x": 2012,
        "y": 45
      },
      {
        "x": 2013,
        "y": 84
      },
      {
        "x": 2014,
        "y": 161
      }
    ]
  },
  {
    "id": "benzylthiouracil",
    "data": [
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 39
      },
      {
        "x": 2010,
        "y": 58
      },
      {
        "x": 2011,
        "y": 60
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 87
      }
    ]
  },
  {
    "id": "beta sitosterol",
    "data": [
      {
        "x": 2007,
        "y": 2
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 14
      },
      {
        "x": 2010,
        "y": 32
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 32
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 32
      }
    ]
  },
  {
    "id": "betadex",
    "data": [
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "butobarbital",
    "data": [
      {
        "x": 2007,
        "y": 3
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 18
      }
    ]
  },
  {
    "id": "clebopride",
    "data": [
      {
        "x": 2007,
        "y": 15
      },
      {
        "x": 2008,
        "y": 40
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 41
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 78
      }
    ]
  },
  {
    "id": "danofloxacin",
    "data": [
      {
        "x": 2007,
        "y": 12
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "dextrothyroxine",
    "data": [
      {
        "x": 2007,
        "y": 13
      },
      {
        "x": 2008,
        "y": 52
      },
      {
        "x": 2009,
        "y": 52
      },
      {
        "x": 2010,
        "y": 52
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 64
      },
      {
        "x": 2014,
        "y": 64
      }
    ]
  },
  {
    "id": "domiphen",
    "data": [
      {
        "x": 2007,
        "y": 2
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 6
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 81
      },
      {
        "x": 2013,
        "y": 186
      },
      {
        "x": 2014,
        "y": 215
      }
    ]
  },
  {
    "id": "fluprednisolone",
    "data": [
      {
        "x": 2007,
        "y": 32
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "furazolidone",
    "data": [
      {
        "x": 2007,
        "y": 5
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 26
      },
      {
        "x": 2010,
        "y": 96
      },
      {
        "x": 2011,
        "y": 155
      },
      {
        "x": 2012,
        "y": 191
      },
      {
        "x": 2013,
        "y": 204
      },
      {
        "x": 2014,
        "y": 440
      }
    ]
  },
  {
    "id": "gadopentetate",
    "data": [
      {
        "x": 2007,
        "y": 6
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 55
      },
      {
        "x": 2010,
        "y": 56
      },
      {
        "x": 2011,
        "y": 61
      },
      {
        "x": 2012,
        "y": 76
      },
      {
        "x": 2013,
        "y": 77
      },
      {
        "x": 2014,
        "y": 116
      }
    ]
  },
  {
    "id": "guaiacol",
    "data": [
      {
        "x": 2007,
        "y": 8
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 308
      },
      {
        "x": 2013,
        "y": 408
      },
      {
        "x": 2014,
        "y": 428
      }
    ]
  },
  {
    "id": "guanidine",
    "data": [
      {
        "x": 2007,
        "y": 3
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 23
      },
      {
        "x": 2012,
        "y": 56
      },
      {
        "x": 2013,
        "y": 105
      },
      {
        "x": 2014,
        "y": 127
      }
    ]
  },
  {
    "id": "hydroflumethiazide",
    "data": [
      {
        "x": 2007,
        "y": 9
      },
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 52
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 162
      },
      {
        "x": 2013,
        "y": 192
      },
      {
        "x": 2014,
        "y": 192
      }
    ]
  },
  {
    "id": "loteprednol",
    "data": [
      {
        "x": 2007,
        "y": 10
      },
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 60
      },
      {
        "x": 2012,
        "y": 196
      },
      {
        "x": 2013,
        "y": 206
      },
      {
        "x": 2014,
        "y": 228
      }
    ]
  },
  {
    "id": "magnesium phosphate",
    "data": [
      {
        "x": 2007,
        "y": 27
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 34
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 48
      },
      {
        "x": 2012,
        "y": 131
      },
      {
        "x": 2013,
        "y": 221
      },
      {
        "x": 2014,
        "y": 277
      }
    ]
  },
  {
    "id": "mesterolone",
    "data": [
      {
        "x": 2007,
        "y": 65
      },
      {
        "x": 2008,
        "y": 142
      },
      {
        "x": 2009,
        "y": 168
      },
      {
        "x": 2010,
        "y": 168
      },
      {
        "x": 2011,
        "y": 248
      },
      {
        "x": 2012,
        "y": 248
      },
      {
        "x": 2013,
        "y": 248
      },
      {
        "x": 2014,
        "y": 250
      }
    ]
  },
  {
    "id": "mitobronitol",
    "data": [
      {
        "x": 2007,
        "y": 3
      },
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "nifurtimox",
    "data": [
      {
        "x": 2007,
        "y": 83
      },
      {
        "x": 2008,
        "y": 108
      },
      {
        "x": 2009,
        "y": 198
      },
      {
        "x": 2010,
        "y": 311
      },
      {
        "x": 2011,
        "y": 368
      },
      {
        "x": 2012,
        "y": 372
      },
      {
        "x": 2013,
        "y": 372
      },
      {
        "x": 2014,
        "y": 372
      }
    ]
  },
  {
    "id": "norfenefrine",
    "data": [
      {
        "x": 2007,
        "y": 18
      },
      {
        "x": 2008,
        "y": 36
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "phenindione",
    "data": [
      {
        "x": 2007,
        "y": 6
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 82
      },
      {
        "x": 2011,
        "y": 91
      },
      {
        "x": 2012,
        "y": 106
      },
      {
        "x": 2013,
        "y": 120
      },
      {
        "x": 2014,
        "y": 276
      }
    ]
  },
  {
    "id": "podophyllin",
    "data": [
      {
        "x": 2007,
        "y": 1
      },
      {
        "x": 2008,
        "y": 32
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 60
      },
      {
        "x": 2011,
        "y": 60
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 123
      },
      {
        "x": 2014,
        "y": 132
      }
    ]
  },
  {
    "id": "potassium bitartrate",
    "data": [
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 25
      }
    ]
  },
  {
    "id": "propionic acid",
    "data": [
      {
        "x": 2007,
        "y": 21
      },
      {
        "x": 2008,
        "y": 24
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 27
      },
      {
        "x": 2011,
        "y": 28
      },
      {
        "x": 2012,
        "y": 28
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "quinfamide",
    "data": [
      {
        "x": 2007,
        "y": 21
      },
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 28
      },
      {
        "x": 2011,
        "y": 28
      },
      {
        "x": 2012,
        "y": 28
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "sulfametrole",
    "data": [
      {
        "x": 2007,
        "y": 4
      },
      {
        "x": 2008,
        "y": 9
      },
      {
        "x": 2009,
        "y": 12
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "talampicillin",
    "data": [
      {
        "x": 2007,
        "y": 2
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "threonine",
    "data": [
      {
        "x": 2007,
        "y": 6
      },
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 27
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "zinc citrate",
    "data": [
      {
        "x": 2007,
        "y": 17
      },
      {
        "x": 2008,
        "y": 44
      },
      {
        "x": 2009,
        "y": 44
      },
      {
        "x": 2010,
        "y": 56
      },
      {
        "x": 2011,
        "y": 56
      },
      {
        "x": 2012,
        "y": 56
      },
      {
        "x": 2013,
        "y": 72
      },
      {
        "x": 2014,
        "y": 80
      }
    ]
  },
  {
    "id": "alcloxa",
    "data": [
      {
        "x": 2008,
        "y": 6
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "antimony potassium tartrate",
    "data": [
      {
        "x": 2008,
        "y": 1
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "azlocillin",
    "data": [
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 25
      }
    ]
  },
  {
    "id": "beclamide",
    "data": [
      {
        "x": 2008,
        "y": 3
      },
      {
        "x": 2009,
        "y": 208
      },
      {
        "x": 2010,
        "y": 418
      },
      {
        "x": 2011,
        "y": 432
      },
      {
        "x": 2012,
        "y": 468
      },
      {
        "x": 2013,
        "y": 508
      },
      {
        "x": 2014,
        "y": 548
      }
    ]
  },
  {
    "id": "carbutamide",
    "data": [
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 10
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 17
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "cromoglycate",
    "data": [
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 40
      },
      {
        "x": 2010,
        "y": 52
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 79
      },
      {
        "x": 2014,
        "y": 88
      }
    ]
  },
  {
    "id": "cyclopentamine",
    "data": [
      {
        "x": 2008,
        "y": 12
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "diclazuril",
    "data": [
      {
        "x": 2008,
        "y": 1
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "diloxanide",
    "data": [
      {
        "x": 2008,
        "y": 6
      },
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 46
      },
      {
        "x": 2014,
        "y": 132
      }
    ]
  },
  {
    "id": "enrofloxacin",
    "data": [
      {
        "x": 2008,
        "y": 2
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "ethylestrenol",
    "data": [
      {
        "x": 2008,
        "y": 6
      },
      {
        "x": 2009,
        "y": 14
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "genistein",
    "data": [
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 32
      },
      {
        "x": 2010,
        "y": 34
      },
      {
        "x": 2011,
        "y": 46
      },
      {
        "x": 2012,
        "y": 77
      },
      {
        "x": 2013,
        "y": 115
      },
      {
        "x": 2014,
        "y": 148
      }
    ]
  },
  {
    "id": "gluconolactone",
    "data": [
      {
        "x": 2008,
        "y": 28
      },
      {
        "x": 2009,
        "y": 28
      },
      {
        "x": 2010,
        "y": 29
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 98
      }
    ]
  },
  {
    "id": "gramicidin",
    "data": [
      {
        "x": 2008,
        "y": 1
      },
      {
        "x": 2009,
        "y": 14
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 88
      },
      {
        "x": 2012,
        "y": 96
      },
      {
        "x": 2013,
        "y": 115
      },
      {
        "x": 2014,
        "y": 172
      }
    ]
  },
  {
    "id": "indigotindisulfonate",
    "data": [
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "iopanoic acid",
    "data": [
      {
        "x": 2008,
        "y": 8
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "kebuzone",
    "data": [
      {
        "x": 2008,
        "y": 22
      },
      {
        "x": 2009,
        "y": 64
      },
      {
        "x": 2010,
        "y": 64
      },
      {
        "x": 2011,
        "y": 64
      },
      {
        "x": 2012,
        "y": 64
      },
      {
        "x": 2013,
        "y": 64
      },
      {
        "x": 2014,
        "y": 74
      }
    ]
  },
  {
    "id": "maropitant",
    "data": [
      {
        "x": 2008,
        "y": 13
      },
      {
        "x": 2009,
        "y": 52
      },
      {
        "x": 2010,
        "y": 52
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 52
      }
    ]
  },
  {
    "id": "meglumine antimoniate",
    "data": [
      {
        "x": 2008,
        "y": 9
      },
      {
        "x": 2009,
        "y": 18
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 51
      },
      {
        "x": 2012,
        "y": 96
      },
      {
        "x": 2013,
        "y": 96
      },
      {
        "x": 2014,
        "y": 157
      }
    ]
  },
  {
    "id": "oxeladin",
    "data": [
      {
        "x": 2008,
        "y": 22
      },
      {
        "x": 2009,
        "y": 84
      },
      {
        "x": 2010,
        "y": 113
      },
      {
        "x": 2011,
        "y": 152
      },
      {
        "x": 2012,
        "y": 152
      },
      {
        "x": 2013,
        "y": 176
      },
      {
        "x": 2014,
        "y": 186
      }
    ]
  },
  {
    "id": "pimethixene",
    "data": [
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "potassium nitrate",
    "data": [
      {
        "x": 2008,
        "y": 9
      },
      {
        "x": 2009,
        "y": 22
      },
      {
        "x": 2010,
        "y": 81
      },
      {
        "x": 2011,
        "y": 108
      },
      {
        "x": 2012,
        "y": 117
      },
      {
        "x": 2013,
        "y": 138
      },
      {
        "x": 2014,
        "y": 165
      }
    ]
  },
  {
    "id": "proscillaridin",
    "data": [
      {
        "x": 2008,
        "y": 18
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "racemethionine",
    "data": [
      {
        "x": 2008,
        "y": 10
      },
      {
        "x": 2009,
        "y": 21
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "rapacuronium",
    "data": [
      {
        "x": 2008,
        "y": 16
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "sulfamerazine",
    "data": [
      {
        "x": 2008,
        "y": 6
      },
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 10
      }
    ]
  },
  {
    "id": "temafloxacin",
    "data": [
      {
        "x": 2008,
        "y": 4
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 18
      },
      {
        "x": 2012,
        "y": 72
      },
      {
        "x": 2013,
        "y": 72
      },
      {
        "x": 2014,
        "y": 72
      }
    ]
  },
  {
    "id": "tenonitrozole",
    "data": [
      {
        "x": 2008,
        "y": 30
      },
      {
        "x": 2009,
        "y": 97
      },
      {
        "x": 2010,
        "y": 116
      },
      {
        "x": 2011,
        "y": 116
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 116
      },
      {
        "x": 2014,
        "y": 116
      }
    ]
  },
  {
    "id": "terpin hydrate",
    "data": [
      {
        "x": 2008,
        "y": 20
      },
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 23
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 27
      },
      {
        "x": 2013,
        "y": 39
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "uric acid",
    "data": [
      {
        "x": 2008,
        "y": 3
      },
      {
        "x": 2009,
        "y": 16
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 92
      },
      {
        "x": 2013,
        "y": 134
      },
      {
        "x": 2014,
        "y": 147
      }
    ]
  },
  {
    "id": "valine",
    "data": [
      {
        "x": 2008,
        "y": 18
      },
      {
        "x": 2009,
        "y": 36
      },
      {
        "x": 2010,
        "y": 58
      },
      {
        "x": 2011,
        "y": 100
      },
      {
        "x": 2012,
        "y": 100
      },
      {
        "x": 2013,
        "y": 100
      },
      {
        "x": 2014,
        "y": 115
      }
    ]
  },
  {
    "id": "vincamine",
    "data": [
      {
        "x": 2008,
        "y": 1
      },
      {
        "x": 2009,
        "y": 18
      },
      {
        "x": 2010,
        "y": 35
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 56
      }
    ]
  },
  {
    "id": "xenon-133",
    "data": [
      {
        "x": 2008,
        "y": 1
      },
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "1-octacosanol",
    "data": [
      {
        "x": 2009,
        "y": 2
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "alitretinoin",
    "data": [
      {
        "x": 2009,
        "y": 5
      },
      {
        "x": 2010,
        "y": 39
      },
      {
        "x": 2011,
        "y": 68
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 123
      },
      {
        "x": 2014,
        "y": 182
      }
    ]
  },
  {
    "id": "amylocaine",
    "data": [
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "androstenedione",
    "data": [
      {
        "x": 2009,
        "y": 48
      },
      {
        "x": 2010,
        "y": 56
      },
      {
        "x": 2011,
        "y": 56
      },
      {
        "x": 2012,
        "y": 56
      },
      {
        "x": 2013,
        "y": 218
      },
      {
        "x": 2014,
        "y": 272
      }
    ]
  },
  {
    "id": "anileridine",
    "data": [
      {
        "x": 2009,
        "y": 54
      },
      {
        "x": 2010,
        "y": 72
      },
      {
        "x": 2011,
        "y": 72
      },
      {
        "x": 2012,
        "y": 73
      },
      {
        "x": 2013,
        "y": 76
      },
      {
        "x": 2014,
        "y": 76
      }
    ]
  },
  {
    "id": "avobenzone",
    "data": [
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 5
      },
      {
        "x": 2014,
        "y": 32
      }
    ]
  },
  {
    "id": "butamben",
    "data": [
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 29
      }
    ]
  },
  {
    "id": "calcium silicate",
    "data": [
      {
        "x": 2009,
        "y": 6
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "chlorotrianisene",
    "data": [
      {
        "x": 2009,
        "y": 24
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 56
      },
      {
        "x": 2012,
        "y": 100
      },
      {
        "x": 2013,
        "y": 115
      },
      {
        "x": 2014,
        "y": 116
      }
    ]
  },
  {
    "id": "epigallocatechin gallate",
    "data": [
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 14
      }
    ]
  },
  {
    "id": "felypressin",
    "data": [
      {
        "x": 2009,
        "y": 8
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 9
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "fenoverine",
    "data": [
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "formic acid",
    "data": [
      {
        "x": 2009,
        "y": 6
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 63
      },
      {
        "x": 2014,
        "y": 80
      }
    ]
  },
  {
    "id": "indole",
    "data": [
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "iodamide",
    "data": [
      {
        "x": 2009,
        "y": 9
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 21
      }
    ]
  },
  {
    "id": "iodipamide",
    "data": [
      {
        "x": 2009,
        "y": 2
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "iodoform",
    "data": [
      {
        "x": 2009,
        "y": 15
      },
      {
        "x": 2010,
        "y": 159
      },
      {
        "x": 2011,
        "y": 228
      },
      {
        "x": 2012,
        "y": 230
      },
      {
        "x": 2013,
        "y": 250
      },
      {
        "x": 2014,
        "y": 253
      }
    ]
  },
  {
    "id": "letosteine",
    "data": [
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "metharbital",
    "data": [
      {
        "x": 2009,
        "y": 20
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "nitric acid",
    "data": [
      {
        "x": 2009,
        "y": 6
      },
      {
        "x": 2010,
        "y": 12
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "orotic acid",
    "data": [
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 120
      },
      {
        "x": 2014,
        "y": 279
      }
    ]
  },
  {
    "id": "phensuximide",
    "data": [
      {
        "x": 2009,
        "y": 5
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 56
      },
      {
        "x": 2013,
        "y": 76
      },
      {
        "x": 2014,
        "y": 100
      }
    ]
  },
  {
    "id": "pipenzolate",
    "data": [
      {
        "x": 2009,
        "y": 6
      },
      {
        "x": 2010,
        "y": 24
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "piperonyl butoxide",
    "data": [
      {
        "x": 2009,
        "y": 22
      },
      {
        "x": 2010,
        "y": 44
      },
      {
        "x": 2011,
        "y": 53
      },
      {
        "x": 2012,
        "y": 56
      },
      {
        "x": 2013,
        "y": 56
      },
      {
        "x": 2014,
        "y": 56
      }
    ]
  },
  {
    "id": "thymine",
    "data": [
      {
        "x": 2009,
        "y": 5
      },
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 59
      },
      {
        "x": 2012,
        "y": 80
      },
      {
        "x": 2013,
        "y": 83
      },
      {
        "x": 2014,
        "y": 131
      }
    ]
  },
  {
    "id": "thymopentin",
    "data": [
      {
        "x": 2009,
        "y": 74
      },
      {
        "x": 2010,
        "y": 92
      },
      {
        "x": 2011,
        "y": 92
      },
      {
        "x": 2012,
        "y": 94
      },
      {
        "x": 2013,
        "y": 109
      },
      {
        "x": 2014,
        "y": 135
      }
    ]
  },
  {
    "id": "titanium",
    "data": [
      {
        "x": 2009,
        "y": 4
      },
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 23
      },
      {
        "x": 2014,
        "y": 31
      }
    ]
  },
  {
    "id": "tocotrienols",
    "data": [
      {
        "x": 2009,
        "y": 87
      },
      {
        "x": 2010,
        "y": 116
      },
      {
        "x": 2011,
        "y": 116
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 116
      },
      {
        "x": 2014,
        "y": 116
      }
    ]
  },
  {
    "id": "tricaprylin",
    "data": [
      {
        "x": 2009,
        "y": 9
      },
      {
        "x": 2010,
        "y": 46
      },
      {
        "x": 2011,
        "y": 76
      },
      {
        "x": 2012,
        "y": 100
      },
      {
        "x": 2013,
        "y": 236
      },
      {
        "x": 2014,
        "y": 403
      }
    ]
  },
  {
    "id": "tripelennamine",
    "data": [
      {
        "x": 2009,
        "y": 11
      },
      {
        "x": 2010,
        "y": 35
      },
      {
        "x": 2011,
        "y": 176
      },
      {
        "x": 2012,
        "y": 229
      },
      {
        "x": 2013,
        "y": 256
      },
      {
        "x": 2014,
        "y": 256
      }
    ]
  },
  {
    "id": "uracil mustard",
    "data": [
      {
        "x": 2009,
        "y": 18
      },
      {
        "x": 2010,
        "y": 36
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 74
      },
      {
        "x": 2013,
        "y": 84
      },
      {
        "x": 2014,
        "y": 84
      }
    ]
  },
  {
    "id": "alpha-ketoglutaric acid",
    "data": [
      {
        "x": 2010,
        "y": 6
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "calcium glucarate",
    "data": [
      {
        "x": 2010,
        "y": 2
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "cefodizime",
    "data": [
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 93
      },
      {
        "x": 2014,
        "y": 98
      }
    ]
  },
  {
    "id": "cyclothiazide",
    "data": [
      {
        "x": 2010,
        "y": 22
      },
      {
        "x": 2011,
        "y": 44
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "debrisoquin",
    "data": [
      {
        "x": 2010,
        "y": 16
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 22
      }
    ]
  },
  {
    "id": "doxacurium",
    "data": [
      {
        "x": 2010,
        "y": 7
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 54
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "ethylenediamine",
    "data": [
      {
        "x": 2010,
        "y": 8
      },
      {
        "x": 2011,
        "y": 16
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "ferric ammonium citrate",
    "data": [
      {
        "x": 2010,
        "y": 1
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 19
      },
      {
        "x": 2013,
        "y": 23
      },
      {
        "x": 2014,
        "y": 92
      }
    ]
  },
  {
    "id": "fospropofol",
    "data": [
      {
        "x": 2010,
        "y": 21
      },
      {
        "x": 2011,
        "y": 40
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "halometasone",
    "data": [
      {
        "x": 2010,
        "y": 20
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "hexobarbital",
    "data": [
      {
        "x": 2010,
        "y": 39
      },
      {
        "x": 2011,
        "y": 48
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 52
      }
    ]
  },
  {
    "id": "levopropoxyphene",
    "data": [
      {
        "x": 2010,
        "y": 28
      },
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 36
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "mebrofenin",
    "data": [
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 18
      }
    ]
  },
  {
    "id": "meclofenamic acid",
    "data": [
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 5
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "mephentermine",
    "data": [
      {
        "x": 2010,
        "y": 18
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "moroxydine",
    "data": [
      {
        "x": 2010,
        "y": 3
      },
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 32
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 32
      }
    ]
  },
  {
    "id": "nialamide",
    "data": [
      {
        "x": 2010,
        "y": 2
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "octopamine",
    "data": [
      {
        "x": 2010,
        "y": 45
      },
      {
        "x": 2011,
        "y": 60
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "oxybenzone",
    "data": [
      {
        "x": 2010,
        "y": 6
      },
      {
        "x": 2011,
        "y": 24
      },
      {
        "x": 2012,
        "y": 30
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "phenindamine",
    "data": [
      {
        "x": 2010,
        "y": 2
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "phenmetrazine",
    "data": [
      {
        "x": 2010,
        "y": 6
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 21
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "phenylmercuric nitrate",
    "data": [
      {
        "x": 2010,
        "y": 52
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 52
      }
    ]
  },
  {
    "id": "polydatin",
    "data": [
      {
        "x": 2010,
        "y": 2
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "propentofylline",
    "data": [
      {
        "x": 2010,
        "y": 5
      },
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "selenious acid",
    "data": [
      {
        "x": 2010,
        "y": 96
      },
      {
        "x": 2011,
        "y": 96
      },
      {
        "x": 2012,
        "y": 108
      },
      {
        "x": 2013,
        "y": 108
      },
      {
        "x": 2014,
        "y": 109
      }
    ]
  },
  {
    "id": "squalane",
    "data": [
      {
        "x": 2010,
        "y": 2
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "strychnine",
    "data": [
      {
        "x": 2010,
        "y": 136
      },
      {
        "x": 2011,
        "y": 136
      },
      {
        "x": 2012,
        "y": 136
      },
      {
        "x": 2013,
        "y": 136
      },
      {
        "x": 2014,
        "y": 136
      }
    ]
  },
  {
    "id": "sulfathiazole",
    "data": [
      {
        "x": 2010,
        "y": 4
      },
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "tiludronate",
    "data": [
      {
        "x": 2010,
        "y": 3
      },
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 18
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "tylosin",
    "data": [
      {
        "x": 2010,
        "y": 11
      },
      {
        "x": 2011,
        "y": 52
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "xanthine",
    "data": [
      {
        "x": 2010,
        "y": 2
      },
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 11
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "2-mercaptoethanesulfonic acid",
    "data": [
      {
        "x": 2011,
        "y": 26
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 52
      }
    ]
  },
  {
    "id": "aminopterin",
    "data": [
      {
        "x": 2011,
        "y": 15
      },
      {
        "x": 2012,
        "y": 60
      },
      {
        "x": 2013,
        "y": 60
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "amitraz",
    "data": [
      {
        "x": 2011,
        "y": 6
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "butalamine",
    "data": [
      {
        "x": 2011,
        "y": 9
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "cantharidin",
    "data": [
      {
        "x": 2011,
        "y": 3
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 28
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "chlorquinaldol",
    "data": [
      {
        "x": 2011,
        "y": 1
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 25
      },
      {
        "x": 2014,
        "y": 88
      }
    ]
  },
  {
    "id": "decanoic acid",
    "data": [
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 9
      },
      {
        "x": 2013,
        "y": 30
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "dibunate",
    "data": [
      {
        "x": 2011,
        "y": 2
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "dimethoxanate",
    "data": [
      {
        "x": 2011,
        "y": 36
      },
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 48
      },
      {
        "x": 2014,
        "y": 48
      }
    ]
  },
  {
    "id": "ferrous carbonate",
    "data": [
      {
        "x": 2011,
        "y": 2
      },
      {
        "x": 2012,
        "y": 109
      },
      {
        "x": 2013,
        "y": 132
      },
      {
        "x": 2014,
        "y": 132
      }
    ]
  },
  {
    "id": "fluorodeoxyglucose f18",
    "data": [
      {
        "x": 2011,
        "y": 40
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "galactose",
    "data": [
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "guanosine",
    "data": [
      {
        "x": 2011,
        "y": 1
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "haloprogin",
    "data": [
      {
        "x": 2011,
        "y": 1
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "hexylresorcinol",
    "data": [
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "levomenthol",
    "data": [
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 136
      },
      {
        "x": 2014,
        "y": 189
      }
    ]
  },
  {
    "id": "manganese citrate",
    "data": [
      {
        "x": 2011,
        "y": 12
      },
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "masoprocol",
    "data": [
      {
        "x": 2011,
        "y": 59
      },
      {
        "x": 2012,
        "y": 116
      },
      {
        "x": 2013,
        "y": 116
      },
      {
        "x": 2014,
        "y": 116
      }
    ]
  },
  {
    "id": "mersalyl",
    "data": [
      {
        "x": 2011,
        "y": 26
      },
      {
        "x": 2012,
        "y": 52
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 52
      }
    ]
  },
  {
    "id": "methoxyphenamine",
    "data": [
      {
        "x": 2011,
        "y": 34
      },
      {
        "x": 2012,
        "y": 65
      },
      {
        "x": 2013,
        "y": 72
      },
      {
        "x": 2014,
        "y": 118
      }
    ]
  },
  {
    "id": "octinoxate",
    "data": [
      {
        "x": 2011,
        "y": 9
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 31
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "oxyphencyclimine",
    "data": [
      {
        "x": 2011,
        "y": 1
      },
      {
        "x": 2012,
        "y": 4
      },
      {
        "x": 2013,
        "y": 10
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "phenoperidine",
    "data": [
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "prenylamine",
    "data": [
      {
        "x": 2011,
        "y": 30
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 40
      }
    ]
  },
  {
    "id": "propylhexedrine",
    "data": [
      {
        "x": 2011,
        "y": 30
      },
      {
        "x": 2012,
        "y": 46
      },
      {
        "x": 2013,
        "y": 80
      },
      {
        "x": 2014,
        "y": 102
      }
    ]
  },
  {
    "id": "resorcinol",
    "data": [
      {
        "x": 2011,
        "y": 20
      },
      {
        "x": 2012,
        "y": 40
      },
      {
        "x": 2013,
        "y": 40
      },
      {
        "x": 2014,
        "y": 64
      }
    ]
  },
  {
    "id": "rimiterol",
    "data": [
      {
        "x": 2011,
        "y": 15
      },
      {
        "x": 2012,
        "y": 20
      },
      {
        "x": 2013,
        "y": 20
      },
      {
        "x": 2014,
        "y": 20
      }
    ]
  },
  {
    "id": "spinosad",
    "data": [
      {
        "x": 2011,
        "y": 4
      },
      {
        "x": 2012,
        "y": 44
      },
      {
        "x": 2013,
        "y": 72
      },
      {
        "x": 2014,
        "y": 78
      }
    ]
  },
  {
    "id": "technetium tc 99m disofenin",
    "data": [
      {
        "x": 2011,
        "y": 32
      },
      {
        "x": 2012,
        "y": 64
      },
      {
        "x": 2013,
        "y": 64
      },
      {
        "x": 2014,
        "y": 64
      }
    ]
  },
  {
    "id": "thyrotropin-releasing hormone",
    "data": [
      {
        "x": 2011,
        "y": 8
      },
      {
        "x": 2012,
        "y": 16
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "aniline",
    "data": [
      {
        "x": 2012,
        "y": 34
      },
      {
        "x": 2013,
        "y": 68
      },
      {
        "x": 2014,
        "y": 68
      }
    ]
  },
  {
    "id": "bismuth oxide",
    "data": [
      {
        "x": 2012,
        "y": 2
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "calcium fluoride",
    "data": [
      {
        "x": 2012,
        "y": 6
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "calcium oxide",
    "data": [
      {
        "x": 2012,
        "y": 9
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 69
      }
    ]
  },
  {
    "id": "cathine",
    "data": [
      {
        "x": 2012,
        "y": 9
      },
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "chlorphenoxamine",
    "data": [
      {
        "x": 2012,
        "y": 24
      },
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 32
      }
    ]
  },
  {
    "id": "dihydroergocornine",
    "data": [
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "dodecyl sulfate",
    "data": [
      {
        "x": 2012,
        "y": 1
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 36
      }
    ]
  },
  {
    "id": "flutrimazole",
    "data": [
      {
        "x": 2012,
        "y": 18
      },
      {
        "x": 2013,
        "y": 48
      },
      {
        "x": 2014,
        "y": 54
      }
    ]
  },
  {
    "id": "guanadrel",
    "data": [
      {
        "x": 2012,
        "y": 2
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "methantheline",
    "data": [
      {
        "x": 2012,
        "y": 46
      },
      {
        "x": 2013,
        "y": 52
      },
      {
        "x": 2014,
        "y": 101
      }
    ]
  },
  {
    "id": "nadh",
    "data": [
      {
        "x": 2012,
        "y": 6
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "niclosamide",
    "data": [
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 16
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "pentagastrin",
    "data": [
      {
        "x": 2012,
        "y": 48
      },
      {
        "x": 2013,
        "y": 48
      },
      {
        "x": 2014,
        "y": 48
      }
    ]
  },
  {
    "id": "pidotimod",
    "data": [
      {
        "x": 2012,
        "y": 90
      },
      {
        "x": 2013,
        "y": 100
      },
      {
        "x": 2014,
        "y": 112
      }
    ]
  },
  {
    "id": "quinaprilat",
    "data": [
      {
        "x": 2012,
        "y": 12
      },
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "thioproperazine",
    "data": [
      {
        "x": 2012,
        "y": 1
      },
      {
        "x": 2013,
        "y": 4
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "thymidine",
    "data": [
      {
        "x": 2012,
        "y": 8
      },
      {
        "x": 2013,
        "y": 8
      },
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "activated attapulgite",
    "data": [
      {
        "x": 2013,
        "y": 72
      },
      {
        "x": 2014,
        "y": 72
      }
    ]
  },
  {
    "id": "alfaxalone",
    "data": [
      {
        "x": 2013,
        "y": 216
      },
      {
        "x": 2014,
        "y": 432
      }
    ]
  },
  {
    "id": "aloglutamol",
    "data": [
      {
        "x": 2013,
        "y": 48
      },
      {
        "x": 2014,
        "y": 86
      }
    ]
  },
  {
    "id": "aprobarbital",
    "data": [
      {
        "x": 2013,
        "y": 9
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "carbenoxolone",
    "data": [
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 86
      }
    ]
  },
  {
    "id": "ceramide 2",
    "data": [
      {
        "x": 2013,
        "y": 3
      },
      {
        "x": 2014,
        "y": 58
      }
    ]
  },
  {
    "id": "chlophedianol",
    "data": [
      {
        "x": 2013,
        "y": 6
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "detomidine",
    "data": [
      {
        "x": 2013,
        "y": 14
      },
      {
        "x": 2014,
        "y": 56
      }
    ]
  },
  {
    "id": "dichlorobenzyl alcohol",
    "data": [
      {
        "x": 2013,
        "y": 2
      },
      {
        "x": 2014,
        "y": 8
      }
    ]
  },
  {
    "id": "dromostanolone",
    "data": [
      {
        "x": 2013,
        "y": 44
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "ethanolamine oleate",
    "data": [
      {
        "x": 2013,
        "y": 32
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "flumethasone",
    "data": [
      {
        "x": 2013,
        "y": 24
      },
      {
        "x": 2014,
        "y": 60
      }
    ]
  },
  {
    "id": "heptanoic acid",
    "data": [
      {
        "x": 2013,
        "y": 3
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "hydroxyethyl cellulose",
    "data": [
      {
        "x": 2013,
        "y": 5
      },
      {
        "x": 2014,
        "y": 28
      }
    ]
  },
  {
    "id": "ibopamine",
    "data": [
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "isopropamide",
    "data": [
      {
        "x": 2013,
        "y": 2
      },
      {
        "x": 2014,
        "y": 25
      }
    ]
  },
  {
    "id": "novobiocin",
    "data": [
      {
        "x": 2013,
        "y": 111
      },
      {
        "x": 2014,
        "y": 444
      }
    ]
  },
  {
    "id": "romifidine",
    "data": [
      {
        "x": 2013,
        "y": 14
      },
      {
        "x": 2014,
        "y": 56
      }
    ]
  },
  {
    "id": "sodium metabisulfite",
    "data": [
      {
        "x": 2013,
        "y": 36
      },
      {
        "x": 2014,
        "y": 44
      }
    ]
  },
  {
    "id": "sodium nitrate",
    "data": [
      {
        "x": 2013,
        "y": 27
      },
      {
        "x": 2014,
        "y": 48
      }
    ]
  },
  {
    "id": "sodium tartrate",
    "data": [
      {
        "x": 2013,
        "y": 12
      },
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "sulfabenzamide",
    "data": [
      {
        "x": 2013,
        "y": 1
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "sulfobromophthalein",
    "data": [
      {
        "x": 2013,
        "y": 3
      },
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "3,3'-diindolylmethane",
    "data": [
      {
        "x": 2014,
        "y": 10
      }
    ]
  },
  {
    "id": "aceglutamide",
    "data": [
      {
        "x": 2014,
        "y": 11
      }
    ]
  },
  {
    "id": "arbutin",
    "data": [
      {
        "x": 2014,
        "y": 25
      }
    ]
  },
  {
    "id": "catechin",
    "data": [
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "chlorogenic acid",
    "data": [
      {
        "x": 2014,
        "y": 12
      }
    ]
  },
  {
    "id": "copper chloride",
    "data": [
      {
        "x": 2014,
        "y": 3
      }
    ]
  },
  {
    "id": "deracoxib",
    "data": [
      {
        "x": 2014,
        "y": 15
      }
    ]
  },
  {
    "id": "diacetyl benzoyl lathyrol",
    "data": [
      {
        "x": 2014,
        "y": 201
      }
    ]
  },
  {
    "id": "dihexyverine",
    "data": [
      {
        "x": 2014,
        "y": 15
      }
    ]
  },
  {
    "id": "fluoride ion",
    "data": [
      {
        "x": 2014,
        "y": 6
      }
    ]
  },
  {
    "id": "hydroxytyrosol",
    "data": [
      {
        "x": 2014,
        "y": 3
      }
    ]
  },
  {
    "id": "methyprylon",
    "data": [
      {
        "x": 2014,
        "y": 5
      }
    ]
  },
  {
    "id": "netupitant",
    "data": [
      {
        "x": 2014,
        "y": 24
      }
    ]
  },
  {
    "id": "nickel sulfate",
    "data": [
      {
        "x": 2014,
        "y": 6
      }
    ]
  },
  {
    "id": "norgestrienone",
    "data": [
      {
        "x": 2014,
        "y": 30
      }
    ]
  },
  {
    "id": "phloretin",
    "data": [
      {
        "x": 2014,
        "y": 16
      }
    ]
  },
  {
    "id": "plicamycin",
    "data": [
      {
        "x": 2014,
        "y": 4
      }
    ]
  },
  {
    "id": "potassium lactate",
    "data": [
      {
        "x": 2014,
        "y": 30
      }
    ]
  },
  {
    "id": "proxyphylline",
    "data": [
      {
        "x": 2014,
        "y": 2
      }
    ]
  },
  {
    "id": "pyrithioxin",
    "data": [
      {
        "x": 2014,
        "y": 2
      }
    ]
  },
  {
    "id": "sodium chlorite",
    "data": [
      {
        "x": 2014,
        "y": 84
      }
    ]
  },
  {
    "id": "temoporfin",
    "data": [
      {
        "x": 2014,
        "y": 9
      }
    ]
  },
  {
    "id": "triacetin",
    "data": [
      {
        "x": 2014,
        "y": 3
      }
    ]
  }
]